<template>
  <v-flex>
    <v-dialog v-model="dialogBusquedaClientes" width="500" persistent>
      <v-card class="mx-auto" outlined :color="colorFondo500" :style="'border: 1px solid grey;'">
        <v-toolbar dense :color="colorBarraFormulario" dark flat>
          <v-toolbar-title v-bind:style="{ color: colorFondo300 }">
            <h5 v-bind:style="{ color: 'white' }">
              RESULTADO DE BUSQUEDA DE CLIENTES
            </h5>
          </v-toolbar-title>
          <v-spacer></v-spacer>

          <v-icon size="30" :color="'white'" @click="dialogBusquedaClientes = false">mdi-close-circle</v-icon>
        </v-toolbar>

        <v-card-text class="mt-0">
          <v-list color="transparent" nav dense>
            <v-list-item-group :color="colorEBikeBarraFormulario">
              <template v-for="client in clientes">
                <v-list-item :key="client.id" v-if="client" @click="_selecCliente(client)">
                  <v-list-item-avatar color="success">
                    <v-avatar size="40px">
                      <v-icon class="ml-0" size="38px">mdi-account-circle</v-icon>
                    </v-avatar>
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title>{{ client.nombre }}</v-list-item-title>
                    <v-list-item-subtitle>{{ client.telefono }}</v-list-item-subtitle>
                    <v-list-item-subtitle>{{ client.email }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-list-item-group>
          </v-list>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogCamposFactura" width="1000" persistent>
      <v-card class="mx-auto" :color="'rgb(250,250,250)'">
        <v-toolbar dense :color="colorBarraFormulario" dark flat>
          <v-toolbar-title v-bind:style="{ color: colorFondo300 }">
            <h5 v-bind:style="{ color: 'white' }">
              DATOS A MOSTRAR EN FACTURA
            </h5>
          </v-toolbar-title>
          <v-spacer></v-spacer>

          <v-icon size="30" :color="'white'" @click="dialogCamposFactura = false">mdi-close-circle</v-icon>
        </v-toolbar>

        <v-card-text class="mt-8">
          <v-row>
            <v-col>
              <v-menu :dark="dark" v-model="date4" :close-on-content-click="false" :nudge-right="40"
                transition="scale-transition" offset-y min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field :dark="dark" clearable dense outlined v-model="campoFacturaFecha"
                    label="Fecha de factura" prepend-icon="mdi-calendar" readonly v-on="on" hide-details></v-text-field>
                </template>
                <v-date-picker :dark="dark" color="success" locale="es" v-model="campoFacturaFecha"
                  @input="date4 = false" first-day-of-week="1"></v-date-picker>
              </v-menu>
            </v-col>
            <v-col></v-col>

            <v-col>

              <v-text-field v-model="campoFacturaClienteNombre" class="" label="Cliente Nombre" type="text" outlined
                dense :dark="dark" autocomplete="false" hide-details>
              </v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col></v-col>
            <v-col></v-col>
            <v-col>
              <v-text-field v-model="campoFacturaClienteDNI" class="" label="Cliente DNI" type="text" outlined dense
                :dark="dark" autocomplete="false" hide-details>
              </v-text-field>
            </v-col>
          </v-row>


          <v-row>
            <v-col></v-col>
            <v-col></v-col>
            <v-col>
              <v-text-field v-model="campoFacturaClienteDomicilio" class="mb-2" label="Cliente Dirección" type="text"
                outlined dense :dark="dark" autocomplete="false" hide-details>
              </v-text-field>
            </v-col>
          </v-row>

          <v-row class="mt-2">
            <v-col cols="4">
              <v-text-field v-model="campoFacturaNumeroFactura" label="Nº FACTURA" type="text" outlined dense :dark="dark"
                autocomplete="false" hide-details>
              </v-text-field>
            </v-col>
            <v-col></v-col>
            <v-col></v-col>
          </v-row>

          <v-row>
            <v-col cols="6">
              <v-textarea v-model="campoFacturaFilas[0].descripcion" label="Descripción" type="text" outlined rows="2"
                dense :dark="dark" autocomplete="false" hide-details>
              </v-textarea>
            </v-col>
            <v-col>
              <v-text-field v-model="campoFacturaFilas[0].unidades" label="Unidades" type="text" outlined dense
                :dark="dark" autocomplete="false" hide-details>
              </v-text-field>
            </v-col>
            <v-col>
              <v-text-field v-model="campoFacturaFilas[0].precio" label="Precio" type="text" outlined dense :dark="dark"
                autocomplete="false" hide-details>
              </v-text-field>
            </v-col>
            <v-col>
              <v-text-field v-model="campoFacturaFilas[0].importe" label="Importe" type="text" outlined dense
                :dark="dark" autocomplete="false" hide-details>
              </v-text-field>
            </v-col>

          </v-row>

          <v-row>
            <v-col cols="6">
              <v-textarea v-model="campoFacturaFilas[1].descripcion" type="text" outlined rows="2" dense :dark="dark"
                autocomplete="false" hide-details>
              </v-textarea>
            </v-col>
            <v-col>
              <v-text-field v-model="campoFacturaFilas[1].unidades" type="text" outlined dense :dark="dark"
                autocomplete="false" hide-details>
              </v-text-field>
            </v-col>
            <v-col>
              <v-text-field v-model="campoFacturaFilas[1].precio" type="text" outlined dense :dark="dark"
                autocomplete="false" hide-details>
              </v-text-field>
            </v-col>
            <v-col>
              <v-text-field v-model="campoFacturaFilas[1].importe" type="text" outlined dense :dark="dark"
                autocomplete="false" hide-details>
              </v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="6">
              <v-textarea v-model="campoFacturaFilas[2].descripcion" type="text" outlined rows="2" dense :dark="dark"
                autocomplete="false" hide-details>
              </v-textarea>
            </v-col>
            <v-col>
              <v-text-field v-model="campoFacturaFilas[2].unidades" type="text" outlined dense :dark="dark"
                autocomplete="false" hide-details>
              </v-text-field>
            </v-col>
            <v-col>
              <v-text-field v-model="campoFacturaFilas[2].precio" type="text" outlined dense :dark="dark"
                autocomplete="false" hide-details>
              </v-text-field>
            </v-col>
            <v-col>
              <v-text-field v-model="campoFacturaFilas[2].importe" type="text" outlined dense :dark="dark"
                autocomplete="false" hide-details>
              </v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="6">
              <v-textarea v-model="campoFacturaFilas[3].descripcion" type="text" outlined rows="2" dense :dark="dark"
                autocomplete="false" hide-details>
              </v-textarea>
            </v-col>
            <v-col>
              <v-text-field v-model="campoFacturaFilas[3].unidades" type="text" outlined dense :dark="dark"
                autocomplete="false" hide-details>
              </v-text-field>
            </v-col>
            <v-col>
              <v-text-field v-model="campoFacturaFilas[3].precio" type="text" outlined dense :dark="dark"
                autocomplete="false" hide-details>
              </v-text-field>
            </v-col>
            <v-col>
              <v-text-field v-model="campoFacturaFilas[3].importe" type="text" outlined dense :dark="dark"
                autocomplete="false" hide-details>
              </v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="6">
              <v-textarea v-model="campoFacturaFilas[4].descripcion" type="text" outlined rows="2" dense :dark="dark"
                autocomplete="false" hide-details>
              </v-textarea>
            </v-col>
            <v-col>
              <v-text-field v-model="campoFacturaFilas[4].unidades" type="text" outlined dense :dark="dark"
                autocomplete="false" hide-details>
              </v-text-field>
            </v-col>
            <v-col>
              <v-text-field v-model="campoFacturaFilas[4].precio" type="text" outlined dense :dark="dark"
                autocomplete="false" hide-details>
              </v-text-field>
            </v-col>
            <v-col>
              <v-text-field v-model="campoFacturaFilas[4].importe" type="text" outlined dense :dark="dark"
                autocomplete="false" hide-details>
              </v-text-field>

            </v-col>
          </v-row>

          <v-row class="mt-4">
            <v-col>
              <v-text-field v-model="campoFacturaBaseImponible" label="BASE IMPONIBLE" type="text" outlined dense
                :dark="dark" autocomplete="false" hide-details>
              </v-text-field>
            </v-col>
            <v-col>
              <v-text-field v-model="campoFacturaIVA" label="IVA (21%)" type="text" outlined dense :dark="dark"
                autocomplete="false" hide-details>
              </v-text-field>
            </v-col>
            <v-col>
              <v-text-field v-model="campoFacturaTotal" label="TOTAL" type="text" outlined dense :dark="dark"
                autocomplete="false" hide-details>
              </v-text-field>
            </v-col>
          </v-row>

          <v-row class="mt-2">
            <v-col>
              <v-text-field v-model="campoFacturaCuentaBancaria1" label="Cuenta 1" type="text" outlined dense :dark="dark"
                autocomplete="false" hide-details>
              </v-text-field>
            </v-col>
            <v-col>
              <v-text-field v-model="campoFacturaBicCuenta1" label="BIC 1" type="text" outlined dense :dark="dark"
                autocomplete="false" hide-details>
              </v-text-field>
            </v-col>
          </v-row>

          <v-row class="mt-2">
            <v-col>
              <v-text-field v-model="campoFacturaCuentaBancaria2" label="Cuenta 2" type="text" outlined dense :dark="dark"
                autocomplete="false" hide-details>
              </v-text-field>
            </v-col>
            <v-col>
              <v-text-field v-model="campoFacturaBicCuenta2" label="BIC 2" type="text" outlined dense :dark="dark"
                autocomplete="false" hide-details>
              </v-text-field>
            </v-col>
          </v-row>

          <v-row class="mt-2 mb-0" justify="center">
            <v-chip label :color="colorAccent2" @click="_recalcularTotalesFactura">
              <v-container>
                <span v-bind:style="{ color: 'white' }">Recalcular Base/IVA/Total</span>
              </v-container>
            </v-chip>
          </v-row>

          <v-row class="mt-8 mb-2" justify="center">
            <v-chip class="mr-4" label :color="colorEBikeAccent1" @click="_generarFactura">
              <v-container>
                <span v-bind:style="{ color: 'white' }">Generar Factura</span>
              </v-container>
            </v-chip>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogCamposConfirmacion" width="800" persistent>
      <v-card class="mx-auto" :color="'rgb(250,250,250)'">
        <v-toolbar dense :color="colorBarraFormulario" dark flat>
          <v-toolbar-title v-bind:style="{ color: colorFondo300 }">
            <h5 v-bind:style="{ color: 'white' }">
              DATOS A MOSTRAR EN LA CONFIRMACIÓN
            </h5>
          </v-toolbar-title>
          <v-spacer></v-spacer>

          <v-icon size="30" :color="'white'" @click="dialogCamposConfirmacion = false">mdi-close-circle</v-icon>
        </v-toolbar>

        <v-card-text class="mt-8">
          <v-row justify="center" align="center">
            <v-col>
              <v-menu :dark="dark" v-model="dateConfirmacionMenu" :close-on-content-click="false" :nudge-right="40"
                transition="scale-transition" offset-y min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field :dark="dark" clearable dense outlined v-model="campoConfirmacionFecha"
                    label="Fecha de la reserva" prepend-icon="mdi-calendar" readonly v-on="on"
                    hide-details></v-text-field>
                </template>
                <v-date-picker :dark="dark" color="success" locale="es" v-model="campoConfirmacionFecha"
                  @input="dateConfirmacionMenu = false" first-day-of-week="1"></v-date-picker>
              </v-menu>

              <v-textarea v-model="campoConfirmacionObservaciones" class="mt-6" label="Observaciones" type="text"
                outlined dense rows="8" :dark="dark" autocomplete="false" hide-details>
              </v-textarea>
            </v-col>
            <v-col justify="center" align="center">
              <v-chip class="mt-0" label :color="colorEBikeAccent1" @click="_generarConfirmacion(true)">
                <v-container>
                  <span v-bind:style="{ color: 'white' }">Confirmación con Condiciones</span>
                </v-container>
              </v-chip>

              <v-chip class="mt-2" label :color="colorEBikeAccent1" @click="_generarConfirmacion(false)">
                <v-container>
                  <span v-bind:style="{ color: 'white' }">Confirmación sin Condiciones</span>
                </v-container>
              </v-chip>

              <v-chip class="mt-2 px-12" label :color="colorEBikeAccent1" @click="_generarConfirmacionIngles(true)">
                <v-container>
                  <span v-bind:style="{ color: 'white' }">Confirmación Inglés</span>
                </v-container>
              </v-chip>

              <v-chip class="mt-2 px-8" label :color="colorEBikeAccent1" @click="_generarConfirmacionPortugues(true)">
                <v-container>
                  <span v-bind:style="{ color: 'white' }">Confirmación Portugués</span>
                </v-container>
              </v-chip>

            </v-col>
          </v-row>






        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogCamposConfirmacionAgencia" width="800" persistent>
      <v-card class="mx-auto" :color="'rgb(250,250,250)'">
        <v-toolbar dense :color="colorBarraFormulario" dark flat>
          <v-toolbar-title v-bind:style="{ color: colorFondo300 }">
            <h5 v-bind:style="{ color: 'white' }">
              DATOS A MOSTRAR EN LA CONFIRMACIÓN DE AGENCIA
            </h5>
          </v-toolbar-title>
          <v-spacer></v-spacer>

          <v-icon size="30" :color="'white'" @click="dialogCamposConfirmacionAgencia = false">mdi-close-circle</v-icon>
        </v-toolbar>

        <v-card-text class="mt-8">
          <v-row justify="center">
            <v-col>
              <v-menu :dark="dark" v-model="dateConfirmacionAgenciaMenu" :close-on-content-click="false" :nudge-right="40"
                transition="scale-transition" offset-y min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field :dark="dark" clearable dense outlined v-model="campoConfirmacionFechaAgencia"
                    label="Fecha de la reserva" prepend-icon="mdi-calendar" readonly v-on="on"
                    hide-details></v-text-field>
                </template>
                <v-date-picker :dark="dark" color="success" locale="es" v-model="campoConfirmacionFechaAgencia"
                  @input="dateConfirmacionAgenciaMenu = false" first-day-of-week="1"></v-date-picker>
              </v-menu>

              <v-textarea v-model="campoConfirmacionObservacionesAgencia" class="mt-6" label="Observaciones" type="text"
                outlined dense rows="6" :dark="dark" autocomplete="false" hide-details>
              </v-textarea>

              <p class="mt-6">Necesitamos los datos del cliente final para la confirmación:</p>

              <v-text-field v-model="campoConfirmacionAgenciaClienteNombre" class="mt-4" label="Nombre" type="text"
                outlined dense :dark="dark" autocomplete="false" hide-details>
              </v-text-field>

              <v-text-field v-model="campoConfirmacionAgenciaClienteDNI" class="mt-4" label="DNI" type="text" outlined
                dense :dark="dark" autocomplete="false" hide-details>
              </v-text-field>

              <v-text-field v-model="campoConfirmacionAgenciaClienteDomicilio" class="mt-4" label="Domicilio"
                type="text" outlined dense :dark="dark" autocomplete="false" hide-details>
              </v-text-field>

              <v-text-field v-model="campoConfirmacionAgenciaClienteTelefono" class="mt-4" label="Teléfono" type="text"
                outlined dense :dark="dark" autocomplete="false" hide-details>
              </v-text-field>

              <v-text-field v-model="campoConfirmacionAgenciaClienteEmail" class="mt-4" label="Email" type="text"
                outlined dense :dark="dark" autocomplete="false" hide-details>
              </v-text-field>






            </v-col>
            <v-col align="center">
              <v-chip class="mt-0" label :color="colorEBikeAccent1" @click="_generarConfirmacionAgencia(true)">
                <v-container>
                  <span v-bind:style="{ color: 'white' }">Confirmación Agencia con Condiciones</span>
                </v-container>
              </v-chip>

              <v-chip class="mt-2" label :color="colorEBikeAccent1" @click="_generarConfirmacionAgencia(false)">
                <v-container>
                  <span v-bind:style="{ color: 'white' }">Confirmación Agencia sin Condiciones</span>
                </v-container>
              </v-chip>


            </v-col>
          </v-row>






        </v-card-text>
      </v-card>
    </v-dialog>


    <v-dialog v-model="dialogCamposPresupuesto" width="800" persistent>
      <v-card class="mx-auto" :color="'rgb(250,250,250)'">
        <v-toolbar dense :color="colorBarraFormulario" dark flat>
          <v-toolbar-title v-bind:style="{ color: colorFondo300 }">
            <h5 v-bind:style="{ color: 'white' }">
              SELECCIONAR IDIOMA DEL PRESUPUESTO
            </h5>
          </v-toolbar-title>
          <v-spacer></v-spacer>

          <v-icon size="30" :color="'white'" @click="dialogCamposPresupuesto = false">mdi-close-circle</v-icon>
        </v-toolbar>

        <v-card-text class="mt-8">
          <v-row justify="center">
            <v-col cols="12" md="6">
              <v-switch
                v-model="imprimirSoloPaginaPrincipal"
                class="mt-0"
                color="success"
                dense
                hide-details
                inset
                label="Imprimir solo página principal"
              ></v-switch>
            </v-col>
          </v-row>

          <v-row class="mt-8 mb-2" justify="center">
            <v-col align="center">
              <v-chip class="mr-0" label :color="colorEBikeAccent1" @click="_generarPresupuesto()">
                <v-container>
                  <span v-bind:style="{ color: 'white' }">Presupuesto en Castellano</span>
                </v-container>
              </v-chip>
            </v-col>

            <v-col align="center">
              <v-chip class="mr-0" label :color="colorEBikeAccent1" @click="_generarPresupuestoIngles()">
                <v-container>
                  <span v-bind:style="{ color: 'white' }">Presupuesto en Inglés</span>
                </v-container>
              </v-chip>
            </v-col>

            <v-col align="center">
              <v-chip class="mr-0" label :color="colorEBikeAccent1" @click="_generarPresupuestoPortugues()">
                <v-container>
                  <span v-bind:style="{ color: 'white' }">Presupuesto en Portugues</span>
                </v-container>
              </v-chip>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogCamposContrato" width="800" persistent content-class="my-custom-dialog">
      <v-card class="mx-auto" :color="'rgb(250,250,250)'">
        <v-toolbar dense :color="colorBarraFormulario" dark flat>
          <v-toolbar-title v-bind:style="{ color: colorFondo300 }">
            <h5 v-bind:style="{ color: 'white' }">
              DATOS A MOSTRAR EN CONTRATO
            </h5>
          </v-toolbar-title>
          <v-spacer></v-spacer>

          <v-icon size="30" :color="'white'" @click="dialogCamposContrato = false">mdi-close-circle</v-icon>
        </v-toolbar>

        <v-card-text class="mt-8">
          <v-text-field v-model="campoContratoHoraInicio" class="mx-4 mb-2" label="Hora Inicio" type="text" outlined
            dense :dark="dark" autocomplete="false" hide-details>
          </v-text-field>

          <v-text-field v-model="campoContratoHoraFin" class="mx-4 mb-6" label="Hora Fin" type="text" outlined dense
            :dark="dark" autocomplete="false" hide-details>
          </v-text-field>

          <v-text-field v-model="campoContratoCasco" class="mx-4 mb-2" label="Cascos" type="text" outlined dense
            :dark="dark" autocomplete="false" hide-details>
          </v-text-field>
          <v-text-field v-model="campoContratoCandado" class="mx-4 mb-2" label="Candados" type="text" outlined dense
            :dark="dark" autocomplete="false" hide-details>
          </v-text-field>
          <v-text-field v-model="campoContratoCargador" class="mx-4 mb-2" label="Cargador" type="text" outlined dense
            :dark="dark" autocomplete="false" hide-details>
          </v-text-field>
          <v-text-field v-model="campoContratoKitPinchazos" class="mx-4 mb-2" label="Kit Pinchazos" type="text" outlined
            dense :dark="dark" autocomplete="false" hide-details>
          </v-text-field>
          <v-text-field v-model="campoContratoAlforjas" class="mx-4 mb-2" label="Alforjas" type="text" outlined dense
            :dark="dark" autocomplete="false" hide-details>
          </v-text-field>
          <v-text-field v-model="campoContratoBateriaExtra" class="mx-4 mb-6" label="Batería Extra" type="text" outlined
            dense :dark="dark" autocomplete="false" hide-details>
          </v-text-field>

          <v-textarea v-model="campoContratoObservaciones" class="mx-4 mb-6" label="Observaciones" type="text" outlined
            dense rows="3" :dark="dark" autocomplete="false" hide-details>
          </v-textarea>

          <v-row class="mt-8 mb-2" justify="center">
            <v-spacer></v-spacer>
            <v-col>
              <v-chip class="ml-0" label :color="colorEBikeAccent1" @click="_generarContrato">
                <v-container>
                  <span v-bind:style="{ color: 'white' }">Contrato en Castellano</span>
                </v-container>
              </v-chip>
            </v-col>
            <v-spacer></v-spacer>
            <v-col>
              <v-chip class="mr-0" label :color="colorEBikeAccent1" @click="_generarContratoIngles">
                <v-container>
                  <span v-bind:style="{ color: 'white' }">Contrato en Inglés</span>
                </v-container>
              </v-chip>
            </v-col>
            <v-spacer></v-spacer>
            <v-col>
              <v-chip class="mr-0" label :color="colorEBikeAccent1" @click="_generarContratoPortuges">
                <v-container>
                  <span v-bind:style="{ color: 'white' }">Contrato en Portugués</span>
                </v-container>
              </v-chip>
            </v-col>
            <v-spacer></v-spacer>

          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showConfirmacionEliminacion" width="500" persistent>
      <v-card :color="'rgb(250,250,250)'">
        <v-toolbar dense :color="colorBarraFormulario" :dark="dark" flat>
          <v-toolbar-title v-bind:style="{ color: colorFondo300 }">
            <h5 v-bind:style="{ color: 'white' }">
              Confirmación de eliminación
            </h5>
          </v-toolbar-title>
          <v-spacer></v-spacer>

          <v-icon size="30" :color="'white'" @click="showConfirmacionEliminacion = false">mdi-close-circle</v-icon>
        </v-toolbar>
        <v-card-text class="mt-0">
          <v-row class="mt-8 mb-1" justify="center">
            <v-label :dark="dark">
              ¿Está seguro que desea eliminar la reserva?
            </v-label>
          </v-row>

          <v-row class="mt-8 mb-2" justify="center">
            <v-chip class="mr-4" label color="blue-grey darken-3" @click="_eliminarReserva()">
              <v-container>
                <span v-bind:style="{ color: 'white' }">Eliminar</span>
              </v-container>
            </v-chip>
            <v-chip label class="ml-4" color="blue-grey darken-3" @click="showConfirmacionEliminacion = false">
              <v-container width="120">
                <span v-bind:style="{ color: 'white' }">Cancelar </span>
              </v-container>
            </v-chip>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showSolapadasConfirmadas" width="500" persistent>
      <v-card :color="'rgb(250,250,250)'">
        <v-toolbar dense :color="colorBarraFormulario" :dark="dark" flat>
          <v-toolbar-title v-bind:style="{ color: colorFondo300 }">
            <h5 v-bind:style="{ color: 'white' }">
              Solapamiento de reservas
            </h5>
          </v-toolbar-title>
          <v-spacer></v-spacer>

          <v-icon size="30" :color="'white'" @click="showSolapadasConfirmadas = false">mdi-close-circle</v-icon>
        </v-toolbar>
        <v-card-text class="mt-0">
          <v-row class="mt-8 mb-1" justify="center">
            <v-label :dark="dark">
              La reserva que está intentando realizar se solapa con otra reserva
              ya confirmada.
            </v-label>
          </v-row>

          <v-row class="mt-8 mb-2" justify="center">

            <v-chip label class="ml-4" color="blue-grey darken-3" @click="showSolapadasConfirmadas = false">
              <v-container width="120">
                <span v-bind:style="{ color: 'white' }">Aceptar </span>
              </v-container>
            </v-chip>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogCamposObtenerUrlPago" width="800" persistent>
      <v-card class="mx-auto" :color="'rgb(250,250,250)'">
        <v-toolbar dense :color="colorBarraFormulario" dark flat>
          <v-toolbar-title v-bind:style="{ color: colorFondo300 }">
            <h5 v-bind:style="{ color: 'white' }">
              DATOS PARA GENERAR URL DE PAGO
            </h5>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-icon size="30" :color="'white'" @click="dialogCamposObtenerUrlPago = false">mdi-close-circle</v-icon>
        </v-toolbar>

        <v-card-text class="mt-8">
          <v-row justify="center">
            <v-col>
              <v-text-field v-model="campoObtenerUrlPagoCodigo" class="mt-0" label="Order" type="text" outlined dense
                :dark="dark" autocomplete="false" hide-details>
              </v-text-field>
              <v-text-field v-model="campoObtenerUrlPagoImporte" class="mt-4" label="Importe" type="text" outlined dense
                :dark="dark" autocomplete="false" hide-details>
              </v-text-field>

            </v-col>
            <v-col align="center">
              <v-chip class="mt-0" label :color="colorEBikeAccent1" @click="_obtenerUrlPago()">
                <v-container>
                  <span v-bind:style="{ color: 'white' }">Generar Url de Pago</span>
                </v-container>
              </v-chip>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-card :color="'rgb(250, 250, 250)'" class="elevation-0">
      <v-toolbar dense :color="colorBarraFormulario" dark flat>
        <v-toolbar-title v-bind:style="{ color: colorFondo300 }">
          <h5 v-bind:style="{ color: 'white' }">FICHA DE LA RESERVA</h5>
        </v-toolbar-title>
        <v-spacer></v-spacer>



        <v-toolbar-title v-if="this.modelReserva" class="mr-8" v-bind:style="{ color: colorFondo300 }">
          <h5 v-bind:style="{ color: 'white' }">
            {{
              (this.modelReserva != null && this.modelReserva.cod_presupuesto != null
                ? ("Presupuesto: " + this.modelReserva.cod_presupuesto) : "")
            }}
            <!--   {{ this.modelReserva == null?'':('Presupuesto: ' + this.modelReserva.created_at.substring(0, 10).replaceAll("-", "") +
                  '_' +
                  this.modelReserva.id) }} -->

          </h5>
        </v-toolbar-title>

        <v-chip v-if="this.accion == 'editar'" class="px-10 mr-5" label text-color="white" link color="red darken-3"
          @click="showConfirmacionEliminacion = true">
          <v-container>
            <span v-bind:style="{ color: 'white' }">Eliminar</span>
          </v-container>
        </v-chip>

        <v-chip class="px-10 mr-5" label :color="_habilitarGuardado() ? '#4CAF50' : '#78909C'" text-color="white"
          :link="_habilitarGuardado()" style="width: 160px" @click="_guardarReserva">
          <h5 class="ml-1" v-if="loading" v-bind:style="{ color: 'white' }">
            Guardando...
          </h5>
          <h5 class="ml-4" v-else v-bind:style="{ color: 'white' }">
            Guardar
          </h5>
        </v-chip>




        <v-icon size="30" :color="'white'" @click="_cerrar">mdi-close-circle</v-icon>
      </v-toolbar>
      <v-card-text>
        <v-row class="mt-0">
          <v-col cols="5">
            <v-row dense>
              <v-col class="ml-0">
                <v-row dense class="mx-4">
                  <v-col>
                    <v-menu :dark="dark" v-model="date1" :close-on-content-click="false" :nudge-right="40"
                      transition="scale-transition" offset-y min-width="290px">
                      <template v-slot:activator="{ on }">
                        <v-text-field :dark="dark" clearable dense outlined v-model="modelReserva.fecha_inicial"
                          label="Fecha de inicio" prepend-icon="mdi-calendar" readonly v-on="on"
                          hide-details></v-text-field>
                      </template>
                      <v-date-picker :dark="dark" color="success" locale="es" v-model="modelReserva.fecha_inicial"
                        @input="date1 = false" first-day-of-week="1" @change="_buscarDisponibilidad()"></v-date-picker>
                    </v-menu>
                  </v-col>

                  <v-col>
                    <v-combobox class="ml-4" v-model="modelReserva.ubicacion_inicial" outlined
                      label="Ubicación de entrega" dense :items="puntosDevolucion" :dark="dark" hide-no-data
                      hide-details></v-combobox>
                  </v-col>
                </v-row>

                <v-row dense class="mx-4">
                  <v-col>
                    <v-menu :dark="dark" v-model="date2" :close-on-content-click="false" :nudge-right="40"
                      transition="scale-transition" offset-y min-width="290px">
                      <template v-slot:activator="{ on }">
                        <v-text-field :dark="dark" clearable dense outlined v-model="modelReserva.fecha_final"
                          label="Fecha final" prepend-icon="mdi-calendar" readonly v-on="on"
                          hide-details></v-text-field>
                      </template>
                      <v-date-picker :dark="dark" color="success" locale="es" :min="modelReserva.fecha_inicial"
                        v-model="modelReserva.fecha_final" @input="date2 = false" first-day-of-week="1"
                        @change="_buscarDisponibilidad()"></v-date-picker>
                    </v-menu>
                  </v-col>

                  <v-col>
                    <v-combobox class="ml-4" v-model="modelReserva.ubicacion_final" outlined
                      label="Ubicación de recogida" dense :items="puntosDevolucion" :dark="dark" hide-no-data
                      hide-details></v-combobox>
                  </v-col>
                </v-row>

                <v-row dense class="mx-4">
                  <v-card class="mx-1 my-0" outlined width="600" :color="colorFondo500"
                    :style="'border: 1px solid grey;'">
                    <v-row dense class="mb-0 mt-0 ml-2 mr-2">
                      <v-col>
                        <span v-bind:style="{ color: colorFront100 }">TALLA</span>
                      </v-col>
                      <v-col cols="3" align="center">
                        <span v-bind:style="{ color: colorFront100 }">UNIDADES</span>
                      </v-col>

                      <v-col align="center">
                        <span v-bind:style="{ color: colorFront100 }">Nº DIAS</span>
                      </v-col>

                      <v-col align="center">
                        <span v-bind:style="{ color: colorFront100 }">PRECIO</span>
                      </v-col>

                      <v-col align="center">
                        <span v-bind:style="{ color: colorFront100 }">IMPORTE</span>
                      </v-col>
                    </v-row>

                    <v-divider></v-divider>

                    <v-row dense class="mb-0 mt-0 ml-2 mr-2">
                      <v-col>
                        <span v-bind:style="{ color: colorFront100 }">S</span>
                      </v-col>
                      <v-col cols="3" align="center">
                        <v-chip label small link :color="modelReserva.cant_dias > 0
                          ? colorAccent1
                          : 'blue-grey lighten-4'
                          " @click="_setCant('s', '-')">
                          <h3 v-bind:style="{ color: 'white' }">-</h3>
                        </v-chip>

                        <v-chip class="mx-1" label small color="white" outlined>
                          <span v-bind:style="{ color: colorFront100 }">
                            <h3>{{ modelReserva.cant_bicis_s }}</h3>
                          </span>
                        </v-chip>
                        <v-chip label small link :color="modelReserva.cant_dias > 0
                          ? colorAccent1
                          : 'blue-grey lighten-4'
                          " @click="_setCant('s', '+')">
                          <h3 v-bind:style="{ color: 'white' }">+</h3>
                        </v-chip>
                      </v-col>
                      <v-col align="center">
                        <span v-bind:style="{ color: colorFront100 }">{{
                          _calculoCantDias
                        }}</span>
                      </v-col>
                      <v-col align="center">
                        <span v-bind:style="{ color: colorFront100 }">{{
                          tarifaActiva
                        }}</span>
                      </v-col>
                      <v-col align="center">
                        <span v-bind:style="{ color: colorFront100 }">
                          {{ _formatImporteVista(importe_s) }}
                        </span>
                      </v-col>
                    </v-row>

                    <v-row dense class="mb-0 mt-0 ml-2 mr-2">
                      <v-col>
                        <span v-bind:style="{ color: colorFront100 }">M</span>
                      </v-col>
                      <v-col cols="3" align="center">
                        <v-chip label small link :color="modelReserva.cant_dias > 0
                          ? colorAccent1
                          : 'blue-grey lighten-4'
                          " @click="_setCant('m', '-')">
                          <h3 v-bind:style="{ color: 'white' }">-</h3>
                        </v-chip>

                        <v-chip class="mx-1" label small color="white" outlined>
                          <span v-bind:style="{ color: colorFront100 }">
                            <h3>{{ modelReserva.cant_bicis_m }}</h3>
                          </span>
                        </v-chip>
                        <v-chip label small link :color="modelReserva.cant_dias > 0
                          ? colorAccent1
                          : 'blue-grey lighten-4'
                          " @click="_setCant('m', '+')">
                          <h3 v-bind:style="{ color: 'white' }">+</h3>
                        </v-chip>
                      </v-col>
                      <v-col align="center">
                        <span v-bind:style="{ color: colorFront100 }">{{
                          _calculoCantDias
                        }}</span>
                      </v-col>
                      <v-col align="center">
                        <span v-bind:style="{ color: colorFront100 }">{{
                          tarifaActiva
                        }}</span>
                      </v-col>
                      <v-col align="center">
                        <span v-bind:style="{ color: colorFront100 }">{{
                          _formatImporteVista(importe_m)
                        }}</span>
                      </v-col>
                    </v-row>

                    <v-row dense class="mb-0 mt-0 ml-2 mr-2">
                      <v-col>
                        <span v-bind:style="{ color: colorFront100 }">L</span>
                      </v-col>
                      <v-col cols="3" align="center">
                        <v-chip label small link :color="modelReserva.cant_dias > 0
                          ? colorAccent1
                          : 'blue-grey lighten-4'
                          " @click="_setCant('l', '-')">
                          <h3 v-bind:style="{ color: 'white' }">-</h3>
                        </v-chip>

                        <v-chip class="mx-1" label small color="white" outlined>
                          <span v-bind:style="{ color: colorFront100 }">
                            <h3>{{ modelReserva.cant_bicis_l }}</h3>
                          </span>
                        </v-chip>
                        <v-chip label small link :color="modelReserva.cant_dias > 0
                          ? colorAccent1
                          : 'blue-grey lighten-4'
                          " @click="_setCant('l', '+')">
                          <h3 v-bind:style="{ color: 'white' }">+</h3>
                        </v-chip>
                      </v-col>
                      <v-col align="center">
                        <span v-bind:style="{ color: colorFront100 }">{{
                          _calculoCantDias
                        }}</span>
                      </v-col>
                      <v-col align="center">
                        <span v-bind:style="{ color: colorFront100 }">{{
                          tarifaActiva
                        }}</span>
                      </v-col>
                      <v-col align="center">
                        <span v-bind:style="{ color: colorFront100 }">{{
                          _formatImporteVista(importe_l)
                        }}</span>
                      </v-col>
                    </v-row>

                    <v-row dense class="mb-0 mt-0 ml-2 mr-2">
                      <v-col>
                        <span v-bind:style="{ color: colorFront100 }">XL</span>
                      </v-col>
                      <v-col cols="3" align="center">
                        <v-chip label small link :color="modelReserva.cant_dias > 0
                          ? colorAccent1
                          : 'blue-grey lighten-4'
                          " @click="_setCant('xl', '-')">
                          <h3 v-bind:style="{ color: 'white' }">-</h3>
                        </v-chip>

                        <v-chip class="mx-1" label small color="white" outlined>
                          <span v-bind:style="{ color: colorFront100 }">
                            <h3>{{ modelReserva.cant_bicis_xl }}</h3>
                          </span>
                        </v-chip>
                        <v-chip label small link :color="modelReserva.cant_dias > 0
                          ? colorAccent1
                          : 'blue-grey lighten-4'
                          " @click="_setCant('xl', '+')">
                          <h3 v-bind:style="{ color: 'white' }">+</h3>
                        </v-chip>
                      </v-col>
                      <v-col align="center">
                        <span v-bind:style="{ color: colorFront100 }">{{
                          _calculoCantDias
                        }}</span>
                      </v-col>
                      <v-col align="center">
                        <span v-bind:style="{ color: colorFront100 }">{{
                          tarifaActiva
                        }}</span>
                      </v-col>
                      <v-col align="center">
                        <span v-bind:style="{ color: colorFront100 }">{{
                          _formatImporteVista(importe_xl)
                        }}</span>
                      </v-col>
                    </v-row>

                    <v-row dense class="mb-0 mt-0 ml-2 mr-2">
                      <v-col>
                        <span v-bind:style="{ color: colorFront100 }">MS</span>
                      </v-col>
                      <v-col cols="3" align="center">
                        <v-chip label small link :color="modelReserva.cant_dias > 0
                          ? colorAccent1
                          : 'blue-grey lighten-4'
                          " @click="_setCant('ms', '-')">
                          <h3 v-bind:style="{ color: 'white' }">-</h3>
                        </v-chip>

                        <v-chip class="mx-1" label small color="white" outlined>
                          <span v-bind:style="{ color: colorFront100 }">
                            <h3>{{ modelReserva.cant_bicis_ms }}</h3>
                          </span>
                        </v-chip>
                        <v-chip label small link :color="modelReserva.cant_dias > 0
                          ? colorAccent1
                          : 'blue-grey lighten-4'
                          " @click="_setCant('ms', '+')">
                          <h3 v-bind:style="{ color: 'white' }">+</h3>
                        </v-chip>
                      </v-col>
                      <v-col align="center">
                        <span v-bind:style="{ color: colorFront100 }">{{
                          _calculoCantDias
                        }}</span>
                      </v-col>
                      <v-col align="center">
                        <span v-bind:style="{ color: colorFront100 }">{{
                          tarifaActivaMuscular
                        }}</span>
                      </v-col>
                      <v-col align="center">
                        <span v-bind:style="{ color: colorFront100 }">{{
                          _formatImporteVista(importe_ms)
                        }}</span>
                      </v-col>
                    </v-row>

                    <v-row dense class="mb-0 mt-0 ml-2 mr-2">
                      <v-col>
                        <span v-bind:style="{ color: colorFront100 }">MM</span>
                      </v-col>
                      <v-col cols="3" align="center">
                        <v-chip label small link :color="modelReserva.cant_dias > 0
                          ? colorAccent1
                          : 'blue-grey lighten-4'
                          " @click="_setCant('mm', '-')">
                          <h3 v-bind:style="{ color: 'white' }">-</h3>
                        </v-chip>

                        <v-chip class="mx-1" label small color="white" outlined>
                          <span v-bind:style="{ color: colorFront100 }">
                            <h3>{{ modelReserva.cant_bicis_mm }}</h3>
                          </span>
                        </v-chip>
                        <v-chip label small link :color="modelReserva.cant_dias > 0
                          ? colorAccent1
                          : 'blue-grey lighten-4'
                          " @click="_setCant('mm', '+')">
                          <h3 v-bind:style="{ color: 'white' }">+</h3>
                        </v-chip>
                      </v-col>
                      <v-col align="center">
                        <span v-bind:style="{ color: colorFront100 }">{{
                          _calculoCantDias
                        }}</span>
                      </v-col>
                      <v-col align="center">
                        <span v-bind:style="{ color: colorFront100 }">{{
                          tarifaActivaMuscular
                        }}</span>
                      </v-col>
                      <v-col align="center">
                        <span v-bind:style="{ color: colorFront100 }">{{
                          _formatImporteVista(importe_mm)
                        }}</span>
                      </v-col>
                    </v-row>

                    <v-row dense class="mb-0 mt-0 ml-2 mr-2">
                      <v-col>
                        <span v-bind:style="{ color: colorFront100 }">ML</span>
                      </v-col>
                      <v-col cols="3" align="center">
                        <v-chip label small link :color="modelReserva.cant_dias > 0
                          ? colorAccent1
                          : 'blue-grey lighten-4'
                          " @click="_setCant('ml', '-')">
                          <h3 v-bind:style="{ color: 'white' }">-</h3>
                        </v-chip>

                        <v-chip class="mx-1" label small color="white" outlined>
                          <span v-bind:style="{ color: colorFront100 }">
                            <h3>{{ modelReserva.cant_bicis_ml }}</h3>
                          </span>
                        </v-chip>
                        <v-chip label small link :color="modelReserva.cant_dias > 0
                          ? colorAccent1
                          : 'blue-grey lighten-4'
                          " @click="_setCant('ml', '+')">
                          <h3 v-bind:style="{ color: 'white' }">+</h3>
                        </v-chip>
                      </v-col>
                      <v-col align="center">
                        <span v-bind:style="{ color: colorFront100 }">{{
                          _calculoCantDias
                        }}</span>
                      </v-col>
                      <v-col align="center">
                        <span v-bind:style="{ color: colorFront100 }">{{
                          tarifaActivaMuscular
                        }}</span>
                      </v-col>
                      <v-col align="center">
                        <span v-bind:style="{ color: colorFront100 }">{{
                          _formatImporteVista(importe_ml)
                        }}</span>
                      </v-col>
                    </v-row>

                    <v-divider></v-divider>

                    <v-row v-if="loadingDisponibilidad">
                      <v-spacer />
                      <v-row class="mt-12 mb-12">
                        <v-col>
                          <v-progress-linear :color="colorEBikeAccent1" indeterminate width="200px" rounded
                            height="6"></v-progress-linear>
                        </v-col>
                      </v-row>
                      <v-spacer />
                    </v-row>

                    <v-row v-else class="ml-1 mt-2 mb-2">
                      <table class="table table-sm mx-2">
                        <caption></caption>
                        <th />
                        <tr v-for="(fila, filaIndex) in _chunkDisponibilidad(disponibilidad_S)"
                          :key="'disp-s-' + filaIndex">
                          <td class="text-center" v-bind:style="{
                            color: colorFront200,
                          }">
                            <v-chip v-if="filaIndex === 0" class="px-2" :color="'blue-grey darken-2'" style="width: 30px" label link
                              text-color="white" small>
                              S
                            </v-chip>
                          </td>

                          <td id="bicis" class="text-center" v-for="bici in fila" v-bind:key="bici.id"
                            v-bind:style="{
                              color: colorFront200,
                            }">
                            <v-chip class="px-1" :color="_colorDisponibilidad(bici)" style="width: 38px" label link
                              text-color="white" small @click="_selecBici(bici)">
                              <span v-bind:style="{ color: 'black' }">
                                {{ bici.talla + "-" + bici.numero }}
                              </span>
                            </v-chip>
                          </td>
                        </tr>

                        <tr v-for="(fila, filaIndex) in _chunkDisponibilidad(disponibilidad_M)"
                          :key="'disp-m-' + filaIndex">
                          <td class="text-center" v-bind:style="{
                            color: colorFront200,
                          }">
                            <v-chip v-if="filaIndex === 0" class="px-2" :color="'blue-grey darken-2'" style="width: 30px" label link
                              text-color="white" small>
                              M
                            </v-chip>
                          </td>

                          <td id="bicis" class="text-center" v-for="bici in fila" v-bind:key="bici.id"
                            v-bind:style="{
                              color: colorFront200,
                            }">
                            <v-chip class="px-1" :color="_colorDisponibilidad(bici)" style="width: 38px" label link
                              text-color="white" small @click="_selecBici(bici)">
                              <span v-bind:style="{ color: 'black' }">
                                {{ bici.talla + "-" + bici.numero }}
                              </span>
                            </v-chip>
                          </td>
                        </tr>

                        <tr v-for="(fila, filaIndex) in _chunkDisponibilidad(disponibilidad_L)"
                          :key="'disp-l-' + filaIndex">
                          <td class="text-center" v-bind:style="{
                            color: colorFront200,
                          }">
                            <v-chip v-if="filaIndex === 0" class="px-2" :color="'blue-grey darken-2'" style="width: 30px" label link
                              text-color="white" small>
                              L
                            </v-chip>
                          </td>

                          <td id="bicis" class="text-center" v-for="bici in fila" v-bind:key="bici.id"
                            v-bind:style="{
                              color: colorFront200,
                            }">
                            <v-chip class="px-1" :color="_colorDisponibilidad(bici)" style="width: 38px" label link
                              text-color="white" small @click="_selecBici(bici)">
                              <span v-bind:style="{ color: 'black' }">
                                {{ bici.talla + "-" + bici.numero }}
                              </span>
                            </v-chip>
                          </td>
                        </tr>

                        <tr v-for="(fila, filaIndex) in _chunkDisponibilidad(disponibilidad_XL)"
                          :key="'disp-xl-' + filaIndex">
                          <td class="text-center" v-bind:style="{
                            color: colorFront200,
                          }">
                            <v-chip v-if="filaIndex === 0" class="px-1" :color="'blue-grey darken-2'" style="width: 30px" label link
                              text-color="white" small>
                              XL
                            </v-chip>
                          </td>

                          <td id="bicis" class="text-center" v-for="bici in fila" v-bind:key="bici.id"
                            v-bind:style="{
                              color: colorFront200,
                            }">
                            <v-chip class="px-1" :color="_colorDisponibilidad(bici)" style="width: 42px" label link
                              text-color="white" small @click="_selecBici(bici)">
                              <span v-bind:style="{ color: 'black' }">
                                {{ bici.talla + "-" + bici.numero }}
                              </span>
                            </v-chip>
                          </td>
                        </tr>



                        <tr v-for="(fila, filaIndex) in _chunkDisponibilidad(disponibilidad_MS)"
                          :key="'disp-ms-' + filaIndex">
                          <td class="text-center" v-bind:style="{
                            color: colorFront200,
                          }">
                            <v-chip v-if="filaIndex === 0" class="px-1" :color="'blue-grey darken-2'" style="width: 30px" label link
                              text-color="white" small>
                              MS
                            </v-chip>
                          </td>

                          <td id="bicis" class="text-center" v-for="bici in fila" v-bind:key="bici.id"
                            v-bind:style="{
                              color: colorFront200,
                            }">
                            <v-chip class="px-1" :color="_colorDisponibilidad(bici)" style="width: 42px" label link
                              text-color="white" small @click="_selecBici(bici)">
                              <span v-bind:style="{ color: 'black' }">
                                {{ bici.talla + bici.numero }}
                              </span>
                            </v-chip>
                          </td>
                        </tr>

                        <tr v-for="(fila, filaIndex) in _chunkDisponibilidad(disponibilidad_MM)"
                          :key="'disp-mm-' + filaIndex">
                          <td class="text-center" v-bind:style="{
                            color: colorFront200,
                          }">
                            <v-chip v-if="filaIndex === 0" class="px-1" :color="'blue-grey darken-2'" style="width: 30px" label link
                              text-color="white" small>
                              MM
                            </v-chip>
                          </td>

                          <td id="bicis" class="text-center" v-for="bici in fila" v-bind:key="bici.id"
                            v-bind:style="{
                              color: colorFront200,
                            }">
                            <v-chip class="px-1" :color="_colorDisponibilidad(bici)" style="width: 42px" label link
                              text-color="white" small @click="_selecBici(bici)">
                              <span v-bind:style="{ color: 'black' }">
                                {{ bici.talla + bici.numero }}
                              </span>
                            </v-chip>
                          </td>
                        </tr>
                        <tr v-for="(fila, filaIndex) in _chunkDisponibilidad(disponibilidad_ML)"
                          :key="'disp-ml-' + filaIndex">
                          <td class="text-center" v-bind:style="{
                            color: colorFront200,
                          }">
                            <v-chip v-if="filaIndex === 0" class="px-1" :color="'blue-grey darken-2'" style="width: 30px" label link
                              text-color="white" small>
                              ML
                            </v-chip>
                          </td>

                          <td id="bicis" class="text-center" v-for="bici in fila" v-bind:key="bici.id"
                            v-bind:style="{
                              color: colorFront200,
                            }">
                            <v-chip class="px-1" :color="_colorDisponibilidad(bici)" style="width: 42px" label link
                              text-color="white" small @click="_selecBici(bici)">
                              <span v-bind:style="{ color: 'black' }">
                                {{ bici.talla + bici.numero }}
                              </span>
                            </v-chip>
                          </td>
                        </tr>
                      </table>
                    </v-row>
                  </v-card>
                </v-row>

                <v-row dense class="mt-2 mx-4">
                  <v-card class="mx-1 my-0" outlined width="600" :color="colorFondo500"
                    :style="'border: 1px solid grey;'">
                    <v-row dense class="mb-0 mt-2 ml-2 mr-2" align="center" justify="center">
                      <v-col>
                        <v-switch class="ml-4 mb-2" hide-details dense label="Sin IVA" v-model="modelReserva.sin_iva"
                          @change="changeSinIva()"></v-switch>
                      </v-col>
                      <v-col cols="4" align="end" justify="center">
                        <span v-bind:style="{ color: colorFront100 }">TOTAL PRESUPUESTO</span>
                      </v-col>
                      <v-col cols="3" align="center">
                        <v-text-field v-model="modelReserva.importe" reverse single-line name="importe" type="text"
                          readonly background-color="blue-grey lighten-4" outlined dense :dark="dark" autocomplete="off"
                          hide-details style="text-align: center">
                        </v-text-field>
                      </v-col>
                    </v-row>

                    <v-row dense class="mb-0 mt-0 ml-2 mr-2" align="center" justify="center">
                      <v-col>
                        <v-switch class="ml-4 mr-6" hide-details dense v-model="modelReserva.descuento_agencia"
                          label="Agencia" @change="changeAgencia()"></v-switch>
                      </v-col>
                      <v-col cols="4" align="end" justify="center">
                        <span v-bind:style="{ color: colorFront100 }">DESCUENTO</span>
                      </v-col>
                      <v-col cols="3" align="center">
                        <v-text-field v-model="modelReserva.descuento" name="descuento" type="text" reverse single-line
                          outlined dense :dark="dark" autocomplete="off" hide-details style="text-align: center"
                          @change="updateImportesTotales()">
                        </v-text-field>
                      </v-col>
                    </v-row>

                    <v-row dense class="mb-0 mt-0 ml-2 mr-2" align="center" justify="center">
                      <v-col> </v-col>
                      <v-col cols="4" align="end" justify="center">
                        <span v-bind:style="{ color: colorFront100 }">FIANZA</span>
                      </v-col>
                      <v-col cols="3" align="center">
                        <v-text-field v-model="modelReserva.fianza" name="fianza" type="text" reverse single-line
                          outlined dense :dark="dark" autocomplete="off" hide-details style="text-align: center"
                          @change="updateImportesTotales()">
                        </v-text-field>
                      </v-col>
                    </v-row>

                    <v-row dense class="mb-2 mt-0 ml-2 mr-2" align="center" justify="center">
                      <v-col cols="9" align="end" justify="center">
                        <span v-bind:style="{ color: colorFront100 }">TOTAL A PAGAR</span>
                      </v-col>
                      <v-col align="center">
                        <v-text-field v-model="modelReserva.total" name="importe" type="text" readonly reverse
                          single-line background-color="blue-grey lighten-4" outlined dense :dark="dark"
                          autocomplete="off" hide-details style="text-align: center">
                        </v-text-field>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-row>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="4">
            <v-row>
              <v-col cols="10">
                <v-select class="mt-0 mr-0" :items="estados" label="Seleccione estado de la reserva" dense :dark="dark"
                  outlined v-model="modelReserva.estado" item-color="green" item-text="nombre" return-object
                  prepend-icon="mdi-checkbox-blank" hide-details>
                  <template v-slot:prepend>
                    <v-icon :color="modelReserva.estado.color">mdi-checkbox-blank</v-icon>
                  </template>
                </v-select>
              </v-col>
              <v-col></v-col>
            </v-row>

            <v-row class="mt-2 mb-0">
              <v-col cols="3">
                <v-text-field v-model="modelReserva.pagado" name="pagado" label="Pagado" type="text" reverse outlined
                  dense :readonly="_esEstadoPresupuesto(modelReserva.estado)" :background-color="_esEstadoPresupuesto(modelReserva.estado)
                    ? 'blue-grey lighten-4'
                    : 'white'
                    " :dark="dark" autocomplete="off" hide-details style="text-align: center"
                  @change="_updatePendiente()">
                </v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field v-model="modelReserva.pendiente" name="pendiente" label="Pendiente" type="text" reverse
                  outlined dense :dark="dark" autocomplete="off" hide-details style="text-align: center" readonly
                  background-color="blue-grey lighten-4">
                </v-text-field>
              </v-col>
              <v-col>
                <v-menu :dark="dark" v-model="date3" :close-on-content-click="false" :nudge-right="40"
                  transition="scale-transition" offset-y min-width="240px">
                  <template v-slot:activator="{ on }">
                    <v-text-field :dark="dark" dense outlined v-model="modelReserva.fecha_bloqueo"
                      label="Bloqueo de transporte" readonly v-on="on" hide-details></v-text-field>
                  </template>
                  <v-date-picker :dark="dark" color="success" locale="es" v-model="modelReserva.fecha_bloqueo"
                    @input="date3 = false" first-day-of-week="1"></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>

            <v-row>
              <v-card class="mx-2 my-1 px-4" outlined width="600" :color="colorFondo500"
                :style="'border: 1px solid grey;'">
                <v-row dense class="mb-0 mt-1 ml-2 mr-2" align="center" justify="center">
                  <v-col cols="1" align="center" justify="center">
                    <span v-bind:style="{ color: colorFront100 }"></span>
                  </v-col>

                  <v-col align="center">
                    <span v-bind:style="{ color: colorFront100 }">Bicis</span>
                  </v-col>

                  <v-col align="center">
                    <span v-bind:style="{ color: colorFront100 }">Cant/Km</span>
                  </v-col>

                  <v-col align="center">
                    <span v-bind:style="{ color: colorFront100 }">Precio/Seur</span>
                  </v-col>

                  <v-col align="center">
                    <span v-bind:style="{ color: colorFront100 }">Precio/Km
                    </span>
                  </v-col>

                  <v-col align="center">
                    <span v-bind:style="{ color: colorFront100 }">Importe</span>
                  </v-col>
                </v-row>

                <v-divider></v-divider>

                <v-row align="center" justify="center" dense class="mb-1 ml-2 mr-2 mt-0">
                  <v-col cols="1" align="center" justify="center">
                    <v-checkbox v-model="incluirTransporte" hide-details class="mb-4"
                      @change="_habilitarTransporte"></v-checkbox>
                  </v-col>

                  <v-col align="center" justify="center">
                    <span v-bind:style="{ color: colorFront100 }">{{
                      this.modelReserva.cant_bicis
                    }}</span>
                  </v-col>
                  <v-col align="center">
                    <v-text-field v-model="modelReserva.transporte_km" name="transporte_km" type="text"
                      :readonly="!incluirTransporte" :background-color="incluirTransporte ? 'white' : 'blue-grey lighten-4'
                        " reverse single-line outlined dense :dark="dark" autocomplete="off" hide-details
                      style="text-align: center" @change="updateDataTransporte">
                    </v-text-field>
                  </v-col>
                  <v-col align="center">
                    <v-text-field v-model="tarifaSEUR" name="transporte_seur" type="text" reverse readonly
                      :background-color="'blue-grey lighten-4'" single-line outlined dense :dark="dark"
                      autocomplete="off" hide-details style="text-align: center" @change="updateDataTransporte">
                    </v-text-field>
                  </v-col>
                  <v-col align="center">
                    <v-text-field v-model="currentTarifaKm" name="transporte_precio" type="text" reverse
                      :readonly="!incluirTransporte" :background-color="incluirTransporte ? 'white' : 'blue-grey lighten-4'
                        " single-line outlined dense :dark="dark" autocomplete="off" hide-details
                      @change="updateDataTransporte">
                    </v-text-field></v-col>
                  <v-col align="center">
                    <v-text-field v-model="modelReserva.transporte_importe" name="transporte_importe" type="text"
                      reverse single-line :readonly="!incluirTransporte" :background-color="incluirTransporte ? 'white' : 'blue-grey lighten-4'
                        " outlined dense :dark="dark" autocomplete="off" hide-details style="text-align: center"
                      @keydown.enter="updateImportesTotales()">
                    </v-text-field>
                  </v-col>
                </v-row>
              </v-card>
            </v-row>

            <v-row>
              <v-card class="mx-2 my-1 px-4 pb-12 mt-8" outlined width="9000" :color="colorFondo500"
                :style="'border: 1px solid grey;'">
                <v-row class="mt-2 mx-6 mb-2 text-center">
                  <v-spacer></v-spacer>
                  <span v-bind:style="{ color: colorFront200 }">Agregue los datos del cliente.
                  </span>
                  <v-spacer></v-spacer>
                </v-row>

                <v-row>
                  <v-text-field v-model="modelReserva.cliente.nombre" class="mx-4 mb-2" label="Nombre" type="text"
                    outlined dense :dark="dark" autocomplete="false" @keypress.enter="
                      _buscarPorNombre(modelReserva.cliente.nombre)
                      " hide-details>
                  </v-text-field>
                </v-row>

                <v-row>
                  <v-text-field v-model="modelReserva.cliente.telefono" class="mx-4 mb-2" label="Teléfono" type="text"
                    outlined dense :dark="dark" autocomplete="false" @keypress.enter="
                      _buscarPorTelefono(modelReserva.cliente.telefono)
                      " hide-details>
                  </v-text-field>
                </v-row>

                <v-row>
                  <v-text-field v-model="modelReserva.cliente.email" class="mx-4 mb-2" label="Email" type="text"
                    outlined dense :dark="dark" autocomplete="false" @keypress.enter="
                      _buscarPorEmail(modelReserva.cliente.email)
                      " hide-details>
                  </v-text-field>
                </v-row>

                <v-row>
                  <v-text-field v-model="modelReserva.cliente.dni" class="mx-4 mb-2" label="DNI" type="text" outlined
                    dense :dark="dark" autocomplete="false" hide-details>
                  </v-text-field>
                </v-row>
                <v-row>
                  <v-textarea v-model="modelReserva.cliente.domicilio" class="mx-4 mb-2" label="Domicilio del cliente"
                    type="text" outlined dense :dark="dark" autocomplete="false" rows="2" hide-details>
                  </v-textarea>
                </v-row>
                <v-row>
                  <v-textarea v-model="modelReserva.cliente.observaciones" class="mx-4 mb-2"
                    label="Observaciones del cliente" type="text" outlined dense :dark="dark" autocomplete="false"
                    rows="2" hide-details>
                  </v-textarea>
                </v-row>

                <v-row>
                  <v-textarea v-model="modelReserva.observaciones" class="mx-4 mb-4" label="Observaciones de la reserva"
                    type="text" outlined dense :dark="dark" autocomplete="false" rows="3" hide-details>
                  </v-textarea>
                </v-row>
              </v-card>
            </v-row>
          </v-col>

          <v-col>
            <v-card class="mx-2 my-2 px-4" outlined :color="colorFondo100" :style="'border: 1px solid grey;'">
              <v-card-text>
                <v-row class="mt-0 mx-6 mb-2 text-center">
                  <v-spacer></v-spacer>
                  <span v-bind:style="{ color: 'white' }">Acciones </span>
                  <v-spacer></v-spacer>
                </v-row>

                <v-row justify="center">
                  <v-chip class="px-10 mb-2" v-bind:style="{ 'min-width': '250px' }" label text-color="white"
                    @click="_mostrarDialogPresupuesto()" :color="this.modelReserva.id != null
                      ? colorEBikeAccent1
                      : '#78909C'
                      " :link="this.modelReserva.id != null">
                    <h5 v-bind:style="{ color: 'white' }">
                      Generar Presupuesto
                    </h5>
                  </v-chip>
                </v-row>

                <v-row justify="center">
                  <v-chip class="px-10 mb-2" v-bind:style="{ 'min-width': '250px' }" label text-color="white"
                    @click="_mostrarDialogConfirmacion()" :color="this.modelReserva.id != null
                      ? colorEBikeAccent1
                      : '#78909C'
                      " :link="this.modelReserva.id != null">
                    <h5 v-bind:style="{ color: 'white' }">
                      Generar Confirmación
                    </h5>
                  </v-chip>
                </v-row>

                <v-row justify="center">
                  <v-chip class="px-10 mb-2" v-bind:style="{ 'min-width': '250px' }" label text-color="white"
                    @click="_mostrarDialogConfirmacionAgencia()" :color="this.modelReserva.id != null
                      ? colorEBikeAccent1
                      : '#78909C'
                      " :link="this.modelReserva.id != null">
                    <h5 v-bind:style="{ color: 'white' }">
                      Generar Confirmación Agencia
                    </h5>
                  </v-chip>
                </v-row>

                <!--   <v-row justify="center">
                  <v-chip
                    class="px-10 mb-2"
                    v-bind:style="{ 'min-width': '250px' }"
                    label
                    text-color="white"
                    @click="_generarConfirmacion(false)"
                    :color="
                      this.modelReserva.id != null
                        ? colorEBikeAccent1
                        : '#78909C'
                    "
                    :link="this.modelReserva.id != null"
                  >
                    <h5 v-bind:style="{ color: 'white' }">
                      Confirmación sin Condiciones
                    </h5>
                  </v-chip>
                </v-row> -->

                <v-row justify="center">
                  <v-chip class="px-10 mb-2" v-bind:style="{ 'min-width': '250px' }" label text-color="white"
                    @click="_mostrarDialogContrato()" :color="this.modelReserva.id != null
                      ? colorEBikeAccent1
                      : '#78909C'
                      " :link="this.modelReserva.id != null">
                    <h5 v-bind:style="{ color: 'white' }">Generar Contrato</h5>
                  </v-chip>
                </v-row>

                <v-row justify="center">
                  <v-chip class="px-10 mb-4" v-bind:style="{ 'min-width': '250px' }" label text-color="white"
                    @click="_mostrarDialogFactura" :color="this.modelReserva.id != null
                      ? colorEBikeAccent1
                      : '#78909C'
                      " :link="this.modelReserva.id != null">
                    <h5 v-bind:style="{ color: 'white' }">Generar Factura</h5>
                  </v-chip>
                </v-row>

                <v-row justify="center">
                  <v-chip class="mt-6 px-10 mb-2" v-bind:style="{ 'min-width': '250px' }" label text-color="white"
                    @click="_mostrarDialogObtenerUrlPago()" :color="this.modelReserva.id != null
                      ? colorEBikeAccent1
                      : '#78909C'
                      " :link="this.modelReserva.id != null">
                    <h5 v-bind:style="{ color: 'white' }">
                      Generar Enlace de Pago
                    </h5>
                  </v-chip>
                </v-row>

                <v-row v-if="modelReserva.url_pago" justify="center">
                  <v-text-field class="mx-4 mb-4 mt-2" v-model="modelReserva.url_pago" label="URL de Pago" readonly outlined
                    dense :dark="!dark" hide-details append-icon="mdi-content-copy"
                    @click:append="_copiarAlPortapapeles(modelReserva.url_pago)"></v-text-field>

                </v-row>

              </v-card-text>
            </v-card>

            <v-card class="mt-4 mx-2 my-2 px-4" outlined :color="colorFondo100" :style="'border: 1px solid grey;'">
              <v-card-text>
                <v-row class="mt-0 mx-6 mb-2 text-center">
                  <v-spacer></v-spacer>
                  <span v-bind:style="{ color: 'white' }">Mensajes </span>
                  <v-spacer></v-spacer>
                </v-row>

                <v-row v-for="mensaje in mensajes" v-bind:key="mensaje.id" justify="center">
                  <v-chip class="px-10 mb-2" v-bind:style="{ 'min-width': '250px' }" label text-color="white" :color="modelReserva.id != null ? colorEBikeAccent1 : '#78909C'
                    " :link="modelReserva.id != null" @click="_enviarMensaje(mensaje)">
                    <v-row justify="center">
                      <h5 v-bind:style="{ color: 'white' }">
                        {{ mensaje.titulo }}
                      </h5>
                    </v-row>
                  </v-chip>
                </v-row>
              </v-card-text>
            </v-card>
            <v-row class="mt-8" dense justify="center" align="center">
              <v-col justify="center" align="left">
                <v-switch class="ml-4" hide-details dense v-model="modelReserva.pedales_automaticos"
                  label="Pedales SPD (Automáticos)" @change="_actualizarImportePedalesAutomaticos"></v-switch>
              </v-col>
              <v-col cols="5" align="right">
                <v-text-field v-model="modelReserva.pedales_automaticos_importe" name="pedales_automaticos_importe"
                  :readonly="!modelReserva.pedales_automaticos"
                  :background-color="modelReserva.pedales_automaticos ? 'white' : 'blue-grey lighten-4'" type="text"
                  class="text-field-reducido" reverse single-line outlined dense :dark="dark" autocomplete="off"
                  hide-details style="text-align: center" @change="updateImportesTotales()">
                </v-text-field>
              </v-col>
            </v-row>

            <v-row dense justify="center" align="center">
              <v-col justify="center" align="left">
                <v-switch class="ml-4" hide-details dense v-model="modelReserva.seguro" label="Seguro Todo Riesgo"
                  @change="_actualizarImporteSeguro"></v-switch>
              </v-col>
              <v-col cols="5" align="right">
                <v-text-field v-model="modelReserva.seguro_importe" name="seguro_importe" type="text"
                  class="text-field-reducido" reverse single-line outlined dense :dark="dark"
                  :readonly="!modelReserva.seguro"
                  :background-color="modelReserva.seguro ? 'white' : 'blue-grey lighten-4'" autocomplete="off"
                  hide-details style="text-align: center" @change="updateImportesTotales()">
                </v-text-field>
              </v-col>
            </v-row>

            <v-row dense justify="center" align="center">
              <v-col justify="center" align="left">
                <v-switch class="ml-4" hide-details dense v-model="modelReserva.bolsa_delantera" label="Bolsa delantera"
                  @change="_actualizarImporteBolsaDelantera"></v-switch>
              </v-col>
              <v-col cols="5" align="right">
                <v-text-field v-model="modelReserva.bolsa_delantera_importe" name="bolsa_delantera_importe" type="text"
                  class="text-field-reducido" reverse single-line outlined dense :dark="dark"
                  :readonly="!modelReserva.bolsa_delantera"
                  :background-color="modelReserva.bolsa_delantera ? 'white' : 'blue-grey lighten-4'" autocomplete="off"
                  hide-details style="text-align: center" @change="updateImportesTotales()">
                </v-text-field>
              </v-col>
            </v-row>

            <v-row dense justify="center" align="center">
              <v-col justify="center" align="left">
                <v-switch class="ml-4" hide-details dense v-model="modelReserva.soporte_movil" label="Soporte móvil"
                  @change="_actualizarImporteSoporteMovil"></v-switch>
              </v-col>
              <v-col cols="5" align="right">
                <v-text-field v-model="modelReserva.soporte_movil_importe" name="soporte_movil_importe" type="text"
                  class="text-field-reducido" reverse single-line outlined dense :dark="dark"
                  :readonly="!modelReserva.soporte_movil"
                  :background-color="modelReserva.soporte_movil ? 'white' : 'blue-grey lighten-4'" autocomplete="off"
                  hide-details style="text-align: center" @change="updateImportesTotales()">
                </v-text-field>
              </v-col>
            </v-row>

            <v-row dense justify="center" align="center">
              <v-col justify="center" align="left">
                <v-switch class="ml-4" hide-details dense v-model="modelReserva.credencial" label="Credencial"
                  @change="_actualizarImporteCredencial"></v-switch>
              </v-col>
              <v-col cols="5" align="right">
                <v-text-field v-model="modelReserva.credencial_importe" name="credencial_importe" type="text"
                  class="text-field-reducido" reverse single-line outlined dense :dark="dark"
                  :readonly="!modelReserva.credencial"
                  :background-color="modelReserva.credencial ? 'white' : 'blue-grey lighten-4'" autocomplete="off"
                  hide-details style="text-align: center" @change="updateImportesTotales()">
                </v-text-field>
              </v-col>
            </v-row>
            <v-row dense justify="center" align="center">
              <v-col>
                <v-switch class="mt-8 ml-4" hide-details dense v-model="modelReserva.casco" label="Casco"></v-switch>
              </v-col>
            </v-row>
            <v-row dense justify="center" align="center">
              <v-col>
                <v-switch class="ml-4" hide-details dense v-model="modelReserva.kit_pinchazos"
                  label="Kit Pinchazos"></v-switch>
              </v-col>
            </v-row>
            <v-row dense justify="center" align="center">
              <v-col>
                <v-switch class="ml-4" hide-details dense v-model="modelReserva.botellin" label="Botellin"></v-switch>
              </v-col>
            </v-row>
            <v-row dense justify="center" align="center">
              <v-col>
                <v-switch class="ml-4" hide-details dense v-model="modelReserva.alforjas" label="Alforjas"></v-switch>
              </v-col>
            </v-row>
            <v-row dense justify="center" align="center">
              <v-col>
                <v-switch class="ml-4" hide-details dense v-model="modelReserva.candado" label="Candado"></v-switch>
              </v-col>
            </v-row>





          </v-col>
        </v-row>

        <v-divider class="mt-8"></v-divider>

        <v-row class="mx-4 mt-2 mb-0">
          <span v-bind:style="{ color: 'black' }">
            {{
              "FACTURA NÚMERO: " +
              (this.modelReserva.factura != null
                ? this.modelReserva.factura
                : "")
            }}
          </span>

          <v-spacer></v-spacer>

          <!--   <v-chip v-if="this.accion == 'editar'" class="px-10 mr-5" label text-color="white" link color="red darken-3"
            @click="showConfirmacionEliminacion = true">
            <v-container>
              <span v-bind:style="{ color: 'white' }">Eliminar</span>
            </v-container>
          </v-chip>

          <v-chip class="px-10" label :color="_habilitarGuardado() ? '#4CAF50' : '#78909C'" text-color="white"
            :link="_habilitarGuardado()" style="width: 160px" @click="_guardarReserva">
            <h5 class="ml-1" v-if="loading" v-bind:style="{ color: 'white' }">
              Guardando...
            </h5>
            <h5 class="ml-4" v-else v-bind:style="{ color: 'white' }">
              Guardar
            </h5>
          </v-chip> -->
        </v-row>
      </v-card-text>
    </v-card>
  </v-flex>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";

var pdfMake = require("pdfmake/build/pdfmake.js");
var pdfFonts = require("pdfmake/build/vfs_fonts.js");
pdfMake.vfs = pdfFonts.pdfMake.vfs;

export default {
  name: "ReservaFormulario",
  components: {},
  data: () => ({
    loading: false,
    loadingDisponibilidad: false,
    date1: false,
    date2: false,
    date3: false,
    date4: false,
    dateConfirmacionMenu: false,
    dateConfirmacionAgenciaMenu: false,

    incluirTransporte: false,
    showConfirmacionEliminacion: false,
    showSolapadasConfirmadas: false,

    estadoInicial: null,



    importe_s: "0.00",
    importe_m: "0.00",
    importe_l: "0.00",
    importe_xl: "0.00",
    importe_ms: "0.00",
    importe_mm: "0.00",
    importe_ml: "0.00",


    tarifaActiva: "-",
    tarifaActivaMuscular: "-",

    arranque: 1,


    dialogBusquedaClientes: false,
    dialogCamposFactura: false,

    // campoFacturaDescripcionAlquiler: "",
    // campoFacturaDescripcionTransporte: "",
    campoFacturaPrecioAlquiler: "",
    campoFacturaPrecioAlquilerMuscular: "",
    campoFacturaPrecioTransporte: "",

    campoFacturaFilas: [
      {
        descripcion: "",
        unidades: "",
        precio: "",
        importe: "",
      },
      {
        descripcion: "",
        unidades: "",
        precio: "",
        importe: "",
      },
      {
        descripcion: "",
        unidades: "",
        precio: "",
        importe: "",
      },
      {
        descripcion: "",
        unidades: "",
        precio: "",
        importe: "",
      },
      {
        descripcion: "",
        unidades: "",
        precio: "",
        importe: "",
      },
    ],

    campoFacturaFecha: "",
    campoFacturaClienteNombre: "",
    campoFacturaClienteDNI: "",
    campoFacturaClienteDomicilio: "",
    campoFacturaNumeroFactura: "",
    campoFacturaNumeroFacturaOriginal: "",
    campoFacturaBaseImponible: "",
    campoFacturaIVA: "",
    campoFacturaTotal: "",
    campoFacturaCuentaBancaria1: "ABANCA: ES83 2080 0306 5130 4002 5574",
    campoFacturaBicCuenta1: "CAGLESMMXXX",
    campoFacturaCuentaBancaria2: "CAIXABANK: ES82 2100 4775 2502 0038 4614",
    campoFacturaBicCuenta2: "CAIXESBBXXX",


    dialogCamposPresupuesto: false,
    campoPresupuestoFecha: "",
    imprimirSoloPaginaPrincipal: false,

    dialogCamposConfirmacion: false,
    campoConfirmacionFecha: "",
    campoConfirmacionObservaciones: "",

    dialogCamposConfirmacionAgencia: false,
    campoConfirmacionFechaAgencia: "",
    campoConfirmacionObservacionesAgencia: "",

    campoConfirmacionAgenciaClienteNombre: "",
    campoConfirmacionAgenciaClienteDNI: "",
    campoConfirmacionAgenciaClienteDomicilio: "",
    campoConfirmacionAgenciaClienteTelefono: "",
    campoConfirmacionAgenciaClienteEmail: "",

    dialogCamposObtenerUrlPago: false,
    campoObtenerUrlPagoImporte: "",
    campoObtenerUrlPagoCodigo: "",


    dialogCamposPresupuesto: false,

    dialogCamposContrato: false,
    campoContratoHoraInicio: "09:00",
    campoContratoHoraFin: "21:00",
    campoContratoCasco: "",
    campoContratoCandado: "",
    campoContratoCargador: "",
    campoContratoKitPinchazos: "",
    campoContratoAlforjas: "",
    campoContratoBateriaExtra: "",
    campoContratoObservaciones: "",

    backupTransporteImporte: "0.00",
    backupDescuento: "0.00",

  }),

  props: {
    modelReserva: {
      type: Object,
      required: true,
    },

    accion: {
      type: String,
      required: true,
    },
  },

  computed: {
    ...mapState([
      "drawer",
      "dark",

      "colorEBikeAccent1",
      "colorEBikeBarraFormulario",

      "puntosDevolucion",

      "colorFondo500",
      "colorFondo400",
      "colorFondo300",
      "colorFondo200",
      "colorFondo100",

      "colorFront500",
      "colorFront400",
      "colorFront300",
      "colorFront200",
      "colorFront100",

      "colorAccent2",
      "colorAccent1",
      "colorBarraFormulario",
    ]),
    ...mapState("auth", [
      "user",
      "date",
      "access_token",
      "error",
      "errorMessage",
      "rutaDocumentosPresupuestos",
      "rutaDocumentosConfirmaciones",
      "rutaDocumentosContratos",
      "rutaDocumentosFacturas",
    ]),
    ...mapState("tarifas", [
      "tarifas",
      "tarifaSelec",

      "tarifaMenosDe7",
      "tarifaMenosDe7SinIVA",
      "tarifaMenosDe7Agencia",
      "tarifaMenosDe7SinIVAAgencia",

      "tarifaMasDe7",
      "tarifaMasDe7SinIVA",
      "tarifaMasDe7Agencia",
      "tarifaMasDe7SinIVAAgencia",

      "muscularMenosDe7",
      "muscularMasDe7",
      "muscularMenosDe7SinIVA",
      "muscularMasDe7SinIVA",
      "muscularMenosDe7Agencia",
      "muscularMasDe7Agencia",
      "muscularMenosDe7SinIVAAgencia",
      "muscularMasDe7SinIVAAgencia",

      "tarifaSEUR",
      "tarifaKm",
      "tarifaFianza",
    ]),
    ...mapState("estados", ["estados"]),
    ...mapState("mensajes", ["mensajes"]),
    ...mapState("clientes", ["clientes"]),
    ...mapState("disponibilidad", [
      "disponibilidad_S",
      "disponibilidad_M",
      "disponibilidad_L",
      "disponibilidad_XL",
      "disponibilidad_MS",
      "disponibilidad_MM",
      "disponibilidad_ML",
    ]),
    ...mapState("reportes", [
      "presupuestoImagen1",
      "presupuestoImagen2",
      "presupuestoImagen3",
      "presupuestoImagen4",
      "presupuestoImagen5",
      "presupuestoImagen6",
      "presupuestoImagen7",
      "presupuestoImagen8",
      "presupuestoImagen12",
      "presupuestoImagen13",
      "presupuestoImagen14",
      "imagenFirma",
    ]),




    _calculoCantDias() {
      if (
        this.modelReserva.fecha_inicial != null &&
        this.modelReserva.fecha_final != null &&
        this.modelReserva.fecha_inicial <= this.modelReserva.fecha_final
      ) {
        const date1Str = new Date(this.modelReserva.fecha_inicial);
        const date2Str = new Date(this.modelReserva.fecha_final);
        const diffTime = Math.abs(date2Str - date1Str);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        this.modelReserva.cant_dias = diffDays + 1;
        return diffDays + 1;
      }
      this.modelReserva.cant_dias = 0;
      return "-";
    },

    /* _calculoTarifaSelecDesdeIva() {
       if (this.modelReserva.sin_iva && !this.arranque) {
         this.descuento_calculado = parseFloat(this.modelReserva.descuento / 1.21).toFixed(2);
       }else{
         this.descuento_calculado = parseFloat(parseFloat(this.modelReserva.descuento_calculado) * 1.21).toFixed(2);
       }
 
       this.arranque = false;
 
 
       if (this.modelReserva.cant_dias > 0 && this.modelReserva.cant_dias <= 7) {
         if (this.modelReserva.descuento_agencia) {
           this.modelReserva.precio = this.tarifaMenosDe7Agencia;
           return this.modelReserva.precio;
         }
         if (this.modelReserva.sin_iva) {
           this.modelReserva.precio = this.tarifaMenosDe7SinIVA;
           return this.modelReserva.precio;
         }
         this.modelReserva.precio = this.tarifaMenosDe7;
         return this.modelReserva.precio;
       } else if (this.modelReserva.cant_dias > 7) {
         if (this.modelReserva.descuento_agencia) {
           this.modelReserva.precio = this.tarifaMasDe7Agencia;
           return this.modelReserva.precio;
         }
         if (this.modelReserva.sin_iva) {
           this.modelReserva.precio = this.tarifaMasDe7SinIVA;
           return this.modelReserva.precio;
         }
         this.modelReserva.precio = this.tarifaMasDe7;
         return this.modelReserva.precio;
       }
       this.modelReserva.precio = 0;
       return "-";
     },*/

    /* _calculoTarifaMuscularSelecDesdeIva() {
       if (this.modelReserva.cant_dias > 0 && this.modelReserva.cant_dias <= 7) {
         if (this.modelReserva.descuento_agencia) {
           this.modelReserva.precio_m = this.muscularMenosDe7Agencia;
           return this.modelReserva.precio_m;
         }
         if (this.modelReserva.sin_iva) {
           this.modelReserva.precio_m = this.muscularMenosDe7SinIVA;
           return this.modelReserva.precio_m;
         }
         this.modelReserva.precio_m = this.muscularMenosDe7;
         return this.modelReserva.precio_m;
       } else if (this.modelReserva.cant_dias > 7) {
         if (this.modelReserva.descuento_agencia) {
           this.modelReserva.precio_m = this.muscularMasDe7Agencia;
           return this.modelReserva.precio_m;
         }
         if (this.modelReserva.sin_iva) {
           this.modelReserva.precio_m = this.muscularMasDe7SinIVA;
           return this.modelReserva.precio_m;
         }
         this.modelReserva.precio_m = this.muscularMasDe7;
         return this.modelReserva.precio_m;
       }
       this.modelReserva.precio_m = 0;
       return "-";
     },*/

    /*  _calculoTarifaSelec() {
        if (this.accion == "editar") {
          return this.modelReserva.precio;
        }
        if (this.modelReserva.cant_dias > 0 && this.modelReserva.cant_dias <= 7) {
          if (this.modelReserva.descuento_agencia) {
            this.modelReserva.precio = this.tarifaMenosDe7Agencia;
            return this.modelReserva.precio;
          }
          if (this.modelReserva.sin_iva) {
            this.modelReserva.precio = this.tarifaMenosDe7SinIVA;
            return this.modelReserva.precio;
          }
          this.modelReserva.precio = this.tarifaMenosDe7;
          return this.modelReserva.precio;
        } else if (this.modelReserva.cant_dias > 7) {
          if (this.modelReserva.descuento_agencia) {
            this.modelReserva.precio = this.tarifaMasDe7Agencia;
            return this.modelReserva.precio;
          }
          if (this.modelReserva.sin_iva) {
            this.modelReserva.precio = this.tarifaMasDe7SinIVA;
            return this.modelReserva.precio;
          }
          this.modelReserva.precio = this.tarifaMasDe7;
          return this.modelReserva.precio;
        }
        this.modelReserva.precio = 0;
        return "-";
      },
  
      _calculoTarifaMuscularSelec() {
        if (this.accion == "editar") {
          return this.modelReserva.precio_m;
        }
        if (this.modelReserva.cant_dias > 0 && this.modelReserva.cant_dias <= 7) {
          if (this.modelReserva.descuento_agencia) {
            this.modelReserva.precio_m = this.muscularMenosDe7Agencia;
            return this.modelReserva.precio_m;
          }
          if (this.modelReserva.sin_iva) {
            this.modelReserva.precio_m = this.muscularMenosDe7SinIVA;
            return this.modelReserva.precio_m;
          }
          this.modelReserva.precio_m = this.muscularMenosDe7;
          return this.modelReserva.precio_m;
        } else if (this.modelReserva.cant_dias > 7) {
          if (this.modelReserva.descuento_agencia) {
            this.modelReserva.precio_m = this.muscularMasDe7Agencia;
            return this.modelReserva.precio;
          }
          if (this.modelReserva.sin_iva) {
            this.modelReserva.precio_m = this.muscularMasDe7SinIVA;
            return this.modelReserva.precio_m;
          }
          this.modelReserva.precio_m = this.muscularMasDe7;
          return this.modelReserva.precio_m;
        }
        this.modelReserva.precio_m = 0;
        return "-";
      },*/

    maxCantBicisS() {
      return this.disponibilidad_S.filter(
        (e) => e.ocupada == false && e.en_reparacion == false
      ).length;
    },

    maxCantBicisM() {
      return this.disponibilidad_M.filter(
        (e) => e.ocupada == false && e.en_reparacion == false
      ).length;
    },

    maxCantBicisL() {
      return this.disponibilidad_L.filter(
        (e) => e.ocupada == false && e.en_reparacion == false
      ).length;
    },

    maxCantBicisXL() {
      return this.disponibilidad_XL.filter(
        (e) => e.ocupada == false && e.en_reparacion == false
      ).length;
    },

    maxCantBicisMS() {
      return this.disponibilidad_MS.filter(
        (e) => e.ocupada == false && e.en_reparacion == false
      ).length;
    },

    maxCantBicisMM() {
      return this.disponibilidad_MM.filter(
        (e) => e.ocupada == false && e.en_reparacion == false
      ).length;
    },

    maxCantBicisML() {
      return this.disponibilidad_ML.filter(
        (e) => e.ocupada == false && e.en_reparacion == false
      ).length;
    },

    currentTarifaKm: {
      get() {
        return this.tarifaKm;
      },
      set(value) {
        this.setTarifaKm(value);
      },
    },
  },

  watch: {
    modelReserva() {
      this._inicializarDatos();

    },
    campoFacturaFilas: {
      handler() {
        if (this.dialogCamposFactura) {
          this._recalcularTotalesFactura();
        }
      },
      deep: true,
    },

    /* "modelReserva.sin_iva": function () {
       /*this.modelReserva.precio = this._calculoTarifaSelecDesdeIva;
       this.modelReserva.precio_m = this._calculoTarifaMuscularSelecDesdeIva;
       this._updateImportesBicis();
       // this.updateImportesTransporte();
     },*/

    /*  "modelReserva.descuento_agencia": function () {
        this.modelReserva.precio = this._calculoTarifaSelecDesdeIva;
        this.modelReserva.precio_m = this._calculoTarifaMuscularSelecDesdeIva;
        this._updateImportesBicis();
      },*/
  },

  mounted() {
    this._inicializarDatos();
  },

  methods: {
    ...mapActions("reservas", [
      "getReservas",
      "crearReserva",
      "updateReserva",
      "eliminarReserva",
      "asignarNumeroFactura",
      "verificarSolapamiento",
      "obtenerUrlPago",
      "obtenerUrlPagoCeca",
      "updateUrlPago",
    ]),
    ...mapActions("clientes", ["getClientes"]),
    ...mapActions("disponibilidad", ["getDisponibilidad"]),
    ...mapMutations("disponibilidad", [
      "setDisponibilidad_S",
      "setDisponibilidad_M",
      "setDisponibilidad_L",
      "setDisponibilidad_XL",
      "setDisponibilidad_MS",
      "setDisponibilidad_MM",
      "setDisponibilidad_ML",
      "setSelecBici",
      "updateSeleccionadasEditar",
    ]),
    ...mapActions("reportes", [
      "reportePresupuesto",
      "reportePresupuestoIngles",
      "reportePresupuestoPortugues",
      "reporteConfirmacion",
      "reporteConfirmacionAgencia",
      "reporteConfirmacionIngles",
      "reporteConfirmacionPortugues",
      "reporteFactura",
      "reporteContrato",
      "reporteContratoIngles",
      "reporteContratoPortuges",
    ]),

    ...mapMutations("tarifas", ["setTarifaKm"]),

    _esEstadoPresupuesto(estado) {
      const estadoId = Number(estado && estado.id);
      return estadoId == 1 || estadoId == 3;
    },

    _inicializarDatos() {
      this.setDisponibilidad_S([]);
      this.setDisponibilidad_M([]);
      this.setDisponibilidad_L([]);
      this.setDisponibilidad_XL([]);
      this.setDisponibilidad_MS([]);
      this.setDisponibilidad_MM([]);
      this.setDisponibilidad_ML([]);

      this.importe_s = "0.00";
      this.importe_m = "0.00";
      this.importe_l = "0.00";
      this.importe_xl = "0.00";
      this.importe_ms = "0.00";
      this.importe_mm = "0.00";
      this.importe_ml = "0.00";

      this.estadoInicial = this.modelReserva.estado.id;


      this.tarifaActiva = "-";
      this.tarifaActivaMuscular = "-";

      if (this.accion == "editar") {
        this._buscarDisponibilidad();
        this.backupTransporteImporte = this.modelReserva.transporte_importe;
        if (this.modelReserva.sin_iva) {
          this.backupDescuento = this.modelReserva.descuento * 1.21;
        } else {
          this.backupDescuento = this.modelReserva.descuento;
        }
        this.tarifaActiva = this.modelReserva.precio;
        this.tarifaActivaMuscular = this.modelReserva.precio_m;

        if (this.modelReserva.transporte_importe != null && this.modelReserva.transporte_importe != '' && this.modelReserva.transporte_importe != 0.00 && this.modelReserva.transporte_importe != '0.00') {
          this.incluirTransporte = true;
        } else {
          this.incluirTransporte = false;
        }
      }
    },

    _copiarAlPortapapeles(texto) {
      navigator.clipboard.writeText(texto);
    },

    _parseImporteFactura(value) {
      if (value === null || value === undefined || value === "") {
        return 0;
      }

      if (typeof value === "number") {
        return Number.isFinite(value) ? value : 0;
      }

      let normalized = String(value).trim().replace(/\s/g, "").replace(/€/g, "");
      if (normalized === "") {
        return 0;
      }

      const hasComma = normalized.includes(",");
      const hasDot = normalized.includes(".");
      if (hasComma && hasDot) {
        if (normalized.lastIndexOf(",") > normalized.lastIndexOf(".")) {
          normalized = normalized.replace(/\./g, "").replace(",", ".");
        } else {
          normalized = normalized.replace(/,/g, "");
        }
      } else if (hasComma) {
        normalized = normalized.replace(/\./g, "").replace(",", ".");
      }

      const parsed = parseFloat(normalized);
      return Number.isFinite(parsed) ? parsed : 0;
    },

    _formatImporteEuropeo(value, includeCurrency = true) {
      const amount = this._parseImporteFactura(value);
      const fixed = amount.toFixed(2);
      const parts = fixed.split(".");
      const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      const decimalPart = parts[1];
      const formatted = integerPart + "," + decimalPart;

      return includeCurrency ? formatted + " €" : formatted;
    },

    _formatImporteVista(value) {
      return this._formatImporteEuropeo(value, false);
    },

    _formatImporteFactura(value) {
      return this._formatImporteEuropeo(value);
    },

    _recalcularTotalesFactura() {
      const base = this.campoFacturaFilas.reduce((sum, fila) => {
        return sum + this._parseImporteFactura(fila.importe);
      }, 0);

      const iva = this.modelReserva.sin_iva ? 0 : parseFloat((base * 0.21).toFixed(2));
      const total = parseFloat((base + iva).toFixed(2));

      this.campoFacturaBaseImponible = this._formatImporteFactura(base);
      this.campoFacturaIVA = this._formatImporteFactura(iva);
      this.campoFacturaTotal = this._formatImporteFactura(total);
    },

    async _eliminarReserva() {
      this.showConfirmacionEliminacion = false;
      if (this.modelReserva.id != null) {
        await this.eliminarReserva([
          this.access_token,
          this.modelReserva.id.toString(),
        ]);
        this._cerrarVentana();
      }
    },

    _actualizarImportePedalesAutomaticos() {
      if (!this.modelReserva.pedales_automaticos) {
        this.modelReserva.pedales_automaticos_importe = '0.00';
      } else if (Number(this.modelReserva.pedales_automaticos_importe) === 0) {
        this.modelReserva.pedales_automaticos_importe = parseFloat(3 * this._calculoCantDias * this.modelReserva.cant_bicis).toFixed(2);
      }
      this.updateImportesTotales();
    },

    _actualizarImporteSeguro() {
      if (!this.modelReserva.seguro) {
        this.modelReserva.seguro_importe = '0.00';
      } else if (Number(this.modelReserva.seguro_importe) === 0) {
        this.modelReserva.seguro_importe = parseFloat(7 * this._calculoCantDias * this.modelReserva.cant_bicis).toFixed(2);
      }
      this.updateImportesTotales();
    },

    _actualizarImporteBolsaDelantera() {
      if (!this.modelReserva.bolsa_delantera) {
        this.modelReserva.bolsa_delantera_importe = '0.00';
      } else if (Number(this.modelReserva.bolsa_delantera_importe) === 0) {
        this.modelReserva.bolsa_delantera_importe = parseFloat(3 * this._calculoCantDias * this.modelReserva.cant_bicis).toFixed(2);
      }
      this.updateImportesTotales();
    },

    _actualizarImporteSoporteMovil() {
      if (!this.modelReserva.soporte_movil) {
        this.modelReserva.soporte_movil_importe = '0.00';
      } else if (Number(this.modelReserva.soporte_movil_importe) === 0) {
        this.modelReserva.soporte_movil_importe = parseFloat(5 * this.modelReserva.cant_bicis).toFixed(2);
      }
      this.updateImportesTotales();
    },

    _actualizarImporteCredencial() {
      if (!this.modelReserva.credencial) {
        this.modelReserva.credencial_importe = '0.00';
      } else if (Number(this.modelReserva.credencial_importe) === 0) {
        this.modelReserva.credencial_importe = parseFloat(5 * this.modelReserva.cant_bicis).toFixed(2);
      }
      this.updateImportesTotales();
    },

    changeSinIva() {
      this._updateTarifaActiva();
      this._updateTarifaActivaMuscular();


      if (this.modelReserva.descuento != null && this.modelReserva.descuento != "" && this.modelReserva.descuento != "0") {
        if (this.modelReserva.sin_iva) {
          this.backupDescuento = this.modelReserva.descuento;
          this.modelReserva.descuento = parseFloat(
            parseFloat(this.backupDescuento) / 1.21
          ).toFixed(2);
        } else {
          this.modelReserva.descuento = parseFloat(
            this.backupDescuento
          ).toFixed(2);
        }
      }

      if (this.modelReserva.sin_iva && this.incluirTransporte) {
        this.backupTransporteImporte = this.modelReserva.transporte_importe;
        this.modelReserva.transporte_importe = parseFloat(
          this.backupTransporteImporte
        ).toFixed(2);
      } else {
        this.modelReserva.transporte_importe = parseFloat(
          this.backupTransporteImporte
        ).toFixed(2);
      }
      this._updateImportesBicis()
    },

    changeAgencia() {
      this._updateTarifaActiva();
      this._updateTarifaActivaMuscular();
      this._updateImportesBicis()

      /*  if (this.modelReserva.agencia) {
          this.backupTransporteImporte = this.modelReserva.transporte_importe;
          this.modelReserva.transporte_importe = parseFloat(
            parseFloat(this.backupTransporteImporte) * 0.85
          ).toFixed(2);
        } else {
          this.modelReserva.transporte_importe = parseFloat(
            this.backupTransporteImporte
          ).toFixed(2);
        }*/
    },

    _tranformarTextoMensajeWh(mensaje) {
      let texto = mensaje.texto
        .replace(
          "&&PRESUPUESTO&&",
          this.modelReserva.created_at.substring(0, 10).replaceAll("-", "") +
          "_" +
          this.modelReserva.id
        )
        .replace("&&FACTURA&&", this.modelReserva.factura);

      return encodeURIComponent(texto);
    },

    _enviarMensaje(mensaje) {
      if (mensaje != null) {
        let body = this._tranformarTextoMensajeWh(mensaje);
        require("electron").shell.openExternal(
          "https://api.whatsapp.com/send?phone=34" +
          this.modelReserva.cliente.telefono.replace(" ", "") +
          "&text=" +
          body,
          "_blank"
        );
      }
    },

    _habilitarGuardado() {
      return (
        this.modelReserva.fecha_inicial != null &&
        this.modelReserva.fecha_final != null &&
        this.modelReserva.cant_bicis > 0 &&

        this.modelReserva.cant_bicis == this.disponibilidad_S.filter((e) => e.seleccion).length +
        this.disponibilidad_M.filter((e) => e.seleccion).length +
        this.disponibilidad_L.filter((e) => e.seleccion).length +
        this.disponibilidad_XL.filter((e) => e.seleccion).length +
        this.disponibilidad_MS.filter((e) => e.seleccion).length +
        this.disponibilidad_MM.filter((e) => e.seleccion).length +
        this.disponibilidad_ML.filter((e) => e.seleccion).length


        /*
          this.disponibilidad_S.filter((e) => e.seleccion).length ==
          this.modelReserva.cant_bicis_s &&
          this.disponibilidad_M.filter((e) => e.seleccion).length ==
          this.modelReserva.cant_bicis_m &&
          this.disponibilidad_L.filter((e) => e.seleccion).length ==
          this.modelReserva.cant_bicis_l &&
          this.disponibilidad_XL.filter((e) => e.seleccion).length ==
          this.modelReserva.cant_bicis_xl &&
          this.disponibilidad_MS.filter((e) => e.seleccion).length ==
          this.modelReserva.cant_bicis_ms &&
          this.disponibilidad_MM.filter((e) => e.seleccion).length ==
          this.modelReserva.cant_bicis_mm &&
          this.disponibilidad_ML.filter((e) => e.seleccion).length ==
          this.modelReserva.cant_bicis_ml
          */
        &&
        this.modelReserva.estado.id != null &&
        this.modelReserva.cliente.nombre != null &&
        this.modelReserva.cliente.telefono != null

      );
    },

    _habilitarTransporte() {
      if (this.incluirTransporte) {
        this.updateImportesTransporte();
        //this.modelReserva.transporte_km = 0;
        //this.modelReserva.transporte_importe = 0.0;
        // this.currentTarifaKm = this.tarifaKm;
      } else {
        //
        this.modelReserva.transporte_km = 0;
        this.modelReserva.transporte_importe = 0.0;

        // this.currentTarifaKm = 0.0;
      }
      this.updateImportesTotales();
    },

    _updatePendiente() {
      if (this.modelReserva.pagado != null && this.modelReserva.pagado != "") {
        this.modelReserva.pagado = parseFloat(this.modelReserva.pagado).toFixed(
          2
        );
        this.modelReserva.pendiente = parseFloat(
          parseFloat(this.modelReserva.total) -
          parseFloat(this.modelReserva.pagado)
        ).toFixed(2);
      }
    },

    _cerrarVentana() {
      this.$emit("cerrarFormularioReserva");
    },

    _cerrar() {
      this.$emit("cerrar");
    },

    _chunkDisponibilidad(list, size = 10) {
      if (!Array.isArray(list) || list.length === 0) {
        return [[]];
      }

      const chunks = [];
      for (let index = 0; index < list.length; index += size) {
        chunks.push(list.slice(index, index + size));
      }
      return chunks;
    },

    _obtenerEstadoDisponibilidad(bici) {
      if (bici == null) {
        return null;
      }

      if (bici.prereservada) {
        return {
          id: 3,
          color: "#69A9E4",
        };
      }

      if (bici.estado && typeof bici.estado == "object") {
        return bici.estado;
      }

      if (bici.reserva_estado && typeof bici.reserva_estado == "object") {
        return bici.reserva_estado;
      }

      if (bici.estado_reserva && typeof bici.estado_reserva == "object") {
        return bici.estado_reserva;
      }

      if (
        bici.reserva &&
        bici.reserva.estado &&
        typeof bici.reserva.estado == "object"
      ) {
        return bici.reserva.estado;
      }

      const estadoId =
        bici.estado_id != null
          ? bici.estado_id
          : bici.reserva_estado_id != null
            ? bici.reserva_estado_id
            : bici.estado_reserva_id != null
              ? bici.estado_reserva_id
              : bici.prereservada
                ? 3
                : bici.presupuestada
                  ? 1
                  : null;

      if (estadoId == null) {
        return null;
      }

      return {
        id: estadoId,
        color:
          bici.estado_color != null
            ? bici.estado_color
            : bici.reserva_estado_color != null
              ? bici.reserva_estado_color
              : bici.estado_reserva_color != null
                ? bici.estado_reserva_color
                : null,
      };
    },

    _colorEstadoDisponibilidad(bici) {
      const estado = this._obtenerEstadoDisponibilidad(bici);
      if (estado == null) {
        return null;
      }

      if (Number(estado.id) == 3) {
        return "#69A9E4";
      }

      if (this._esEstadoPresupuesto(estado)) {
        return estado.color || "#FFFF00";
      }

      return null;
    },

    _colorDisponibilidad(bici) {
      if (bici.seleccion) {
        return "#2979FF"; //azul fuerte
      }
      if (bici.en_reparacion) {
        return "#F44336"; //rojo fuerte
      }
      if (bici.bloqueada && !bici.ocupada) {
        return "#8fc292"; //verde claro
      }
      if (bici.ocupada) {
        return "#43A047"; //verde fuerte
      }
      const colorEstado = this._colorEstadoDisponibilidad(bici);
      if (colorEstado) {
        return colorEstado;
      }
      if (bici.presupuestada) {
        return "#FFFF00"; //amarillo fuerte
      }


      return "blue-grey lighten-4";
    },

    _selecBici(bici) {
      if (!bici.en_reparacion && !bici.ocupada) {
        if (!bici.seleccion) {
          switch (bici.talla) {
            case "S":
              if (
                this.disponibilidad_S.filter((e) => e.seleccion).length <
                this.modelReserva.cant_bicis_s
              ) {
                this.setSelecBici(bici);
              }
              break;
            case "M":
              if (
                this.disponibilidad_M.filter((e) => e.seleccion).length <
                this.modelReserva.cant_bicis_m
              ) {
                this.setSelecBici(bici);
              }
              break;
            case "L":
              if (
                this.disponibilidad_L.filter((e) => e.seleccion).length <
                this.modelReserva.cant_bicis_l
              ) {
                this.setSelecBici(bici);
              }
              break;
            case "XL":
              if (
                this.disponibilidad_XL.filter((e) => e.seleccion).length <
                this.modelReserva.cant_bicis_xl
              ) {
                this.setSelecBici(bici);
              }
              break;
            case "MS":
              if (
                this.disponibilidad_MS.filter((e) => e.seleccion).length <
                this.modelReserva.cant_bicis_ms
              ) {
                this.setSelecBici(bici);
              }
              break;
            case "MM":
              if (
                this.disponibilidad_MM.filter((e) => e.seleccion).length <
                this.modelReserva.cant_bicis_mm
              ) {
                this.setSelecBici(bici);
              }
              break;
            case "ML":
              if (
                this.disponibilidad_ML.filter((e) => e.seleccion).length <
                this.modelReserva.cant_bicis_ml
              ) {
                this.setSelecBici(bici);
              }
              break;

            default:
              break;
          }
        } else {
          this.setSelecBici(bici);
        }
      }
    },

    _buscarPorTelefono(value) {
      const params = {};
      params.telefono = value;
      this._buscarcliente(params);
    },

    _buscarPorNombre(value) {
      const params = {};
      params.nombre = value;
      this._buscarcliente(params);
    },

    _buscarPorEmail(value) {
      const params = {};
      params.email = value;
      this._buscarcliente(params);
    },



    async _buscarDisponibilidad() {
      if (
        this.modelReserva.fecha_inicial != null &&
        this.modelReserva.fecha_inicial != "" &&
        (this.modelReserva.fecha_final == null ||
          this.modelReserva.fecha_final == "" || this.modelReserva.fecha_final < this.modelReserva.fecha_inicial)
      ) {
        this.modelReserva.fecha_final = this.modelReserva.fecha_inicial;

      }
      if (
        this.modelReserva.fecha_inicial != null &&
        this.modelReserva.fecha_inicial != "" &&
        (this.modelReserva.fecha_bloqueo == null ||
          this.modelReserva.fecha_bloqueo == "")
      ) {
        this.modelReserva.fecha_bloqueo = this.modelReserva.fecha_inicial;
      } else {
        if (this.modelReserva.fecha_bloqueo > this.modelReserva.fecha_inicial) {
          this.modelReserva.fecha_bloqueo = this.modelReserva.fecha_inicial;
        }

      }

      if (
        this.modelReserva.fecha_inicial != null &&
        this.modelReserva.fecha_inicial != "" &&
        this.modelReserva.fecha_final != null &&
        this.modelReserva.fecha_final != "" &&
        this.modelReserva.fecha_inicial <= this.modelReserva.fecha_final
      ) {
        this.loadingDisponibilidad = true;

        await this.getDisponibilidad([
          this.access_token,
          this.modelReserva.fecha_inicial,
          this.modelReserva.fecha_final,
        ]);
        if (this.accion == "editar") {
          this.updateSeleccionadasEditar(this.modelReserva.bicis);
        }

        this._updateTarifaActiva();
        this._updateTarifaActivaMuscular();
        this._updateImportesBicis();
        this.loadingDisponibilidad = false;
      }
    },

    async _buscarcliente(params) {
      if (this.modelReserva.id == null) {
        await this.getClientes([this.access_token, params, false]);
        if (this.clientes && this.clientes.length) {
          this.dialogBusquedaClientes = true;
        } else {
        }
      }
    },

    _selecCliente(client) {
      this.modelReserva.cliente = client;
      this.dialogBusquedaClientes = false;
    },

    _setCant(talla, accion) {
      if (this.modelReserva.cant_dias > 0) {
        switch (talla) {
          case "s":
            if (accion == "-") {
              this.modelReserva.cant_bicis_s > 0
                ? (this.modelReserva.cant_bicis_s =
                  this.modelReserva.cant_bicis_s - 1)
                : (this.modelReserva.cant_bicis_s = 0);
            } else if (accion == "+") {
              this.modelReserva.cant_bicis_s < this.maxCantBicisS
                ? (this.modelReserva.cant_bicis_s =
                  this.modelReserva.cant_bicis_s + 1)
                : (this.modelReserva.cant_bicis_s = this.maxCantBicisS);
            }
            break;
          case "m":
            if (accion == "-") {
              this.modelReserva.cant_bicis_m > 0
                ? (this.modelReserva.cant_bicis_m =
                  this.modelReserva.cant_bicis_m - 1)
                : (this.modelReserva.cant_bicis_m = 0);
            } else if (accion == "+") {
              this.modelReserva.cant_bicis_m < this.maxCantBicisM
                ? (this.modelReserva.cant_bicis_m =
                  this.modelReserva.cant_bicis_m + 1)
                : (this.modelReserva.cant_bicis_m = this.maxCantBicisM);
            }
            break;
          case "l":
            if (accion == "-") {
              this.modelReserva.cant_bicis_l > 0
                ? (this.modelReserva.cant_bicis_l =
                  this.modelReserva.cant_bicis_l - 1)
                : (this.modelReserva.cant_bicis_l = 0);
            } else if (accion == "+") {
              this.modelReserva.cant_bicis_l < this.maxCantBicisL
                ? (this.modelReserva.cant_bicis_l =
                  this.modelReserva.cant_bicis_l + 1)
                : (this.modelReserva.cant_bicis_l = this.maxCantBicisL);
            }
            break;
          case "xl":
            if (accion == "-") {
              this.modelReserva.cant_bicis_xl > 0
                ? (this.modelReserva.cant_bicis_xl =
                  this.modelReserva.cant_bicis_xl - 1)
                : (this.modelReserva.cant_bicis_xl = 0);
            } else if (accion == "+") {
              this.modelReserva.cant_bicis_xl < this.maxCantBicisXL
                ? (this.modelReserva.cant_bicis_xl =
                  this.modelReserva.cant_bicis_xl + 1)
                : (this.modelReserva.cant_bicis_xl = this.maxCantBicisXL);
            }
            break;
          case "ms":
            if (accion == "-") {
              this.modelReserva.cant_bicis_ms > 0
                ? (this.modelReserva.cant_bicis_ms =
                  this.modelReserva.cant_bicis_ms - 1)
                : (this.modelReserva.cant_bicis_ms = 0);
            } else if (accion == "+") {
              this.modelReserva.cant_bicis_ms < this.maxCantBicisMS
                ? (this.modelReserva.cant_bicis_ms =
                  this.modelReserva.cant_bicis_ms + 1)
                : (this.modelReserva.cant_bicis_ms = this.maxCantBicisMS);
            }
            break;
          case "mm":
            if (accion == "-") {
              this.modelReserva.cant_bicis_mm > 0
                ? (this.modelReserva.cant_bicis_mm =
                  this.modelReserva.cant_bicis_mm - 1)
                : (this.modelReserva.cant_bicis_mm = 0);
            } else if (accion == "+") {
              this.modelReserva.cant_bicis_mm < this.maxCantBicisMM
                ? (this.modelReserva.cant_bicis_mm =
                  this.modelReserva.cant_bicis_mm + 1)
                : (this.modelReserva.cant_bicis_mm = this.maxCantBicisMM);
            }
            break;

          case "ml":
            if (accion == "-") {
              this.modelReserva.cant_bicis_ml > 0
                ? (this.modelReserva.cant_bicis_ml =
                  this.modelReserva.cant_bicis_ml - 1)
                : (this.modelReserva.cant_bicis_ml = 0);
            } else if (accion == "+") {
              this.modelReserva.cant_bicis_ml < this.maxCantBicisML
                ? (this.modelReserva.cant_bicis_ml =
                  this.modelReserva.cant_bicis_ml + 1)
                : (this.modelReserva.cant_bicis_ml = this.maxCantBicisML);
            }
            break;

          default:
            break;
        }

        this._updateImportesBicis();
      }
    },

    _updateImportesBicis() {
      this.modelReserva.cant_bicis =
        this.modelReserva.cant_bicis_s +
        this.modelReserva.cant_bicis_m +
        this.modelReserva.cant_bicis_l +
        this.modelReserva.cant_bicis_xl +
        this.modelReserva.cant_bicis_ms +
        this.modelReserva.cant_bicis_mm +
        this.modelReserva.cant_bicis_ml;

      this.importe_s = parseFloat(
        this.modelReserva.cant_bicis_s *
        this.modelReserva.cant_dias *
        this.modelReserva.precio
      ).toFixed(2);

      this.importe_m = parseFloat(
        this.modelReserva.cant_bicis_m *
        this.modelReserva.cant_dias *
        this.modelReserva.precio
      ).toFixed(2);

      this.importe_l = parseFloat(
        this.modelReserva.cant_bicis_l *
        this.modelReserva.cant_dias *
        this.modelReserva.precio
      ).toFixed(2);

      this.importe_xl = parseFloat(
        this.modelReserva.cant_bicis_xl *
        this.modelReserva.cant_dias *
        this.modelReserva.precio
      ).toFixed(2);

      this.importe_ms = parseFloat(
        this.modelReserva.cant_bicis_ms *
        this.modelReserva.cant_dias *
        this.modelReserva.precio_m
      ).toFixed(2);

      this.importe_mm = parseFloat(
        this.modelReserva.cant_bicis_mm *
        this.modelReserva.cant_dias *
        this.modelReserva.precio_m
      ).toFixed(2);

      this.importe_ml = parseFloat(
        this.modelReserva.cant_bicis_ml *
        this.modelReserva.cant_dias *
        this.modelReserva.precio_m
      ).toFixed(2);

      // this.modelReserva.fianza = parseFloat(this.tarifaFianza).toFixed(2);

      this.updateImportesTransporte();
      this.updateImportesTotales();
    },

    updateDataTransporte() {
      this.updateImportesTransporte();
      this.updateImportesTotales();
    },



    updateImportesTransporte() {
      if (this.incluirTransporte) {
        if (
          this.modelReserva.transporte_km != null &&
          this.modelReserva.transporte_km > 0
        ) {
          this.modelReserva.transporte_importe = parseFloat(
            this.modelReserva.transporte_km * this.tarifaKm
          ).toFixed(2);
        } else {
          if (this.modelReserva.cant_bicis > 0) {
            this.modelReserva.transporte_importe = parseFloat(
              this.modelReserva.cant_bicis * this.tarifaSEUR
            ).toFixed(2);
          }
        }

        if (
          this.modelReserva.transporte_importe > 0 &&
          this.modelReserva.sin_iva
        ) {
          this.modelReserva.transporte_importe = parseFloat(
            parseFloat(this.modelReserva.transporte_importe) / 1.21
          ).toFixed(2);
        }


      }
    },

    validarCampoNumero(campo) {
      return campo && !isNaN(campo) ? parseFloat(campo) : 0;
    },

    updateImportesTotales() {
      this.modelReserva.importe = parseFloat(
        this.validarCampoNumero(this.importe_s) +
        this.validarCampoNumero(this.importe_m) +
        this.validarCampoNumero(this.importe_l) +
        this.validarCampoNumero(this.importe_xl) +
        this.validarCampoNumero(this.importe_ms) +
        this.validarCampoNumero(this.importe_mm) +
        this.validarCampoNumero(this.importe_ml) +
        this.validarCampoNumero(this.modelReserva.transporte_importe) +
        this.validarCampoNumero(this.modelReserva.pedales_automaticos_importe) +
        this.validarCampoNumero(this.modelReserva.seguro_importe) +
        this.validarCampoNumero(this.modelReserva.bolsa_delantera_importe) +
        this.validarCampoNumero(this.modelReserva.soporte_movil_importe) +
        this.validarCampoNumero(this.modelReserva.credencial_importe)
      ).toFixed(2);
      this.modelReserva.total = parseFloat(
        this.validarCampoNumero(this.modelReserva.importe) +
        this.validarCampoNumero(this.modelReserva.fianza) -
        this.validarCampoNumero(this.modelReserva.descuento)
      ).toFixed(2);
      this._updatePendiente();
    },

    _adjuntaBicis() {
      this.modelReserva.bicis = [];
      this.disponibilidad_S.forEach((bici) => {
        if (bici.seleccion) {
          this.modelReserva.bicis.push({
            id: bici.id,
            marca: bici.marca,
            talla: bici.talla,
            numero: bici.numero,
            observaciones: bici.observaciones,
          });
        }
      });
      this.disponibilidad_M.forEach((bici) => {
        if (bici.seleccion) {
          this.modelReserva.bicis.push({
            id: bici.id,
            marca: bici.marca,
            talla: bici.talla,
            numero: bici.numero,
            observaciones: bici.observaciones,
          });
        }
      });
      this.disponibilidad_L.forEach((bici) => {
        if (bici.seleccion) {
          this.modelReserva.bicis.push({
            id: bici.id,
            marca: bici.marca,
            talla: bici.talla,
            numero: bici.numero,
            observaciones: bici.observaciones,
          });
        }
      });
      this.disponibilidad_XL.forEach((bici) => {
        if (bici.seleccion) {
          this.modelReserva.bicis.push({
            id: bici.id,
            marca: bici.marca,
            talla: bici.talla,
            numero: bici.numero,
            observaciones: bici.observaciones,
          });
        }
      });
      this.disponibilidad_MS.forEach((bici) => {
        if (bici.seleccion) {
          this.modelReserva.bicis.push({
            id: bici.id,
            marca: bici.marca,
            talla: bici.talla,
            numero: bici.numero,
            observaciones: bici.observaciones,
          });
        }
      });
      this.disponibilidad_MM.forEach((bici) => {
        if (bici.seleccion) {
          this.modelReserva.bicis.push({
            id: bici.id,
            marca: bici.marca,
            talla: bici.talla,
            numero: bici.numero,
            observaciones: bici.observaciones,
          });
        }
      });
      this.disponibilidad_ML.forEach((bici) => {
        if (bici.seleccion) {
          this.modelReserva.bicis.push({
            id: bici.id,
            marca: bici.marca,
            talla: bici.talla,
            numero: bici.numero,
            observaciones: bici.observaciones,
          });
        }
      });
    },

    _verificarSolapamientoConfirmadas() {
      return this.reservasCalendario.filter(
        (e) =>
          e.id != this.modelReserva.id &&
          e.estado.id == 2 &&
          ((this.modelReserva.fecha_inicial >= e.fecha_inicial &&
            this.modelReserva.fecha_inicial <= e.fecha_final) ||
            (this.modelReserva.fecha_final >= e.fecha_inicial &&
              this.modelReserva.fecha_final <= e.fecha_final) ||
            (this.modelReserva.fecha_inicial <= e.fecha_inicial &&
              this.modelReserva.fecha_final >= e.fecha_final)));
    },

    async _guardarReserva() {
      if (this._habilitarGuardado()) {
        if (this.modelReserva.estado.id != this.estadoInicial && this.modelReserva.estado.id == 2) {
          var existeSolapamiento = await this.verificarSolapamiento([
            this.access_token,
            this.modelReserva.id
          ]);
          if (existeSolapamiento) {
            this.showSolapadasConfirmadas = true;
            return;
          }
        }

        this.loading = true;
        const params = {};
        if (this.accion == "crear") {
          this._adjuntaBicis();
          var res = await this.crearReserva([
            this.access_token,
            this.modelReserva

          ]);
          if (res != null) {
            this.modelReserva.id = res.id;
            this.modelReserva.cod_presupuesto = res.cod_presupuesto;
            this.modelReserva.created_at = res.created_at;
          }
          this.accion = "editar";
          this.$emit("actualizar");
        } else if (this.accion == "editar") {
          this._adjuntaBicis();
          var res = await this.updateReserva([
            this.access_token,
            this.modelReserva

          ]);
          this._cerrarVentana();
        }
        this.loading = false;
      }
    },

    _captionFecha(fecha) {
      if (fecha) {
        return (
          fecha.substring(8, 10) +
          "/" +
          fecha.substring(5, 7) +
          "/" +
          fecha.substring(0, 4)
        );
      } else {
        return "";
      }
    },

    _updateTarifaActiva() {
      if (this.accion == "editar") {
        this.tarifaActiva = this.modelReserva.precio;
        this.tarifaActivaMuscular = this.modelReserva.precio_m;
      } else {
        if (this.modelReserva.cant_dias <= 0) {
          this.modelReserva.precio = 0;
          this.tarifaActiva = "-";
        } else if (this.modelReserva.cant_dias > 0 && this.modelReserva.cant_dias <= 7) {
          if (!this.modelReserva.descuento_agencia && !this.modelReserva.sin_iva) {
            this.modelReserva.precio = this.tarifaMenosDe7;
            this.tarifaActiva = this.modelReserva.precio;
          } else if (this.modelReserva.sin_iva && this.modelReserva.descuento_agencia) {
            this.modelReserva.precio = this.tarifaMenosDe7SinIVAAgencia;
            this.tarifaActiva = this.modelReserva.precio;
          } else if (this.modelReserva.sin_iva) {
            this.modelReserva.precio = this.tarifaMenosDe7SinIVA;
            this.tarifaActiva = this.modelReserva.precio;
          } else if (this.modelReserva.descuento_agencia) {
            this.modelReserva.precio = this.tarifaMenosDe7Agencia;
            this.tarifaActiva = this.modelReserva.precio;
          }
        } else if (this.modelReserva.cant_dias > 7) {
          if (!this.modelReserva.descuento_agencia && !this.modelReserva.sin_iva) {
            this.modelReserva.precio = this.tarifaMasDe7;
            this.tarifaActiva = this.modelReserva.precio;
          } else if (this.modelReserva.sin_iva && this.modelReserva.descuento_agencia) {
            this.modelReserva.precio = this.tarifaMasDe7SinIVAAgencia;
            this.tarifaActiva = this.modelReserva.precio;
          } else if (this.modelReserva.sin_iva) {
            this.modelReserva.precio = this.tarifaMasDe7SinIVA;
            this.tarifaActiva = this.modelReserva.precio;
          } else if (this.modelReserva.descuento_agencia) {
            this.modelReserva.precio = this.tarifaMasDe7Agencia;
            this.tarifaActiva = this.modelReserva.precio;
          }
        }
      }
    },

    _updateTarifaActivaMuscular() {
      /* if (this.accion == "editar") {
        this.tarifaActiva = this.modelReserva.precio;
      }*/
      if (this.modelReserva.cant_dias <= 0) {
        this.modelReserva.precio_m = 0;
        this.tarifaActivaMuscular = "-";
      } else if (this.modelReserva.cant_dias > 0 && this.modelReserva.cant_dias <= 7) {
        if (!this.modelReserva.descuento_agencia && !this.modelReserva.sin_iva) {
          this.modelReserva.precio_m = this.muscularMenosDe7;
          this.tarifaActivaMuscular = this.modelReserva.precio_m;
        } else if (this.modelReserva.sin_iva && this.modelReserva.descuento_agencia) {
          this.modelReserva.precio_m = this.muscularMenosDe7SinIVAAgencia;
          this.tarifaActivaMuscular = this.modelReserva.precio_m;
        } else if (this.modelReserva.sin_iva) {
          this.modelReserva.precio_m = this.muscularMenosDe7SinIVA;
          this.tarifaActivaMuscular = this.modelReserva.precio_m;
        } else if (this.modelReserva.descuento_agencia) {
          this.modelReserva.precio_m = this.muscularMenosDe7Agencia;
          this.tarifaActivaMuscular = this.modelReserva.precio_m;
        }
      } else if (this.modelReserva.cant_dias > 7) {
        if (!this.modelReserva.descuento_agencia && !this.modelReserva.sin_iva) {
          this.modelReserva.precio_m = this.muscularMasDe7;
          this.tarifaActivaMuscular = this.modelReserva.precio_m;
        } else if (this.modelReserva.sin_iva && this.modelReserva.descuento_agencia) {
          this.modelReserva.precio_m = this.muscularMasDe7SinIVAAgencia;
          this.tarifaActivaMuscular = this.modelReserva.precio_m;
        } else if (this.modelReserva.sin_iva) {
          this.modelReserva.precio_m = this.muscularMasDe7SinIVA;
          this.tarifaActivaMuscular = this.modelReserva.precio_m;
        } else if (this.modelReserva.descuento_agencia) {
          this.modelReserva.precio_m = this.muscularMasDe7Agencia;
          this.tarifaActivaMuscular = this.modelReserva.precio_m;
        }
      }
    },

    async _generarPresupuesto() {
      if (this.modelReserva.id != null) {
        var docDefinition = await this.reportePresupuesto([
          this.modelReserva,
          this.presupuestoImagen1,
          this.presupuestoImagen2,
          this.presupuestoImagen3,
          this.presupuestoImagen4,
          this.presupuestoImagen5,
          this.presupuestoImagen6,
          this.presupuestoImagen7,
          this.presupuestoImagen8,
          this.presupuestoImagen12,
          this.presupuestoImagen13,
          this.presupuestoImagen14,
          this.tarifaSEUR,
          this.tarifaKm,
          this.importe_s,
          this.importe_m,
          this.importe_l,
          this.importe_xl,
          this.importe_ms,
          this.importe_mm,
          this.importe_ml,
          this.tarifaMenosDe7,
          this.tarifaMasDe7,
          this.imprimirSoloPaginaPrincipal,
        ]);

        this.dialogCamposPresupuesto = false;

        pdfMake
          .createPdf(docDefinition)
          .download(
            this.modelReserva.cod_presupuesto +
            "_" +
            this.modelReserva.cliente.nombre.replaceAll(" ", "") +
            "_Presupuesto.pdf"
          );

        /* require("electron").shell.showItemInFolder(
           this.rutaDocumentosPresupuestos +
             this.modelReserva.created_at.substring(0, 10).replaceAll("-", "") +
             "_" +
             this.modelReserva.id.toString() +
             "_" +
             this.modelReserva.cliente.nombre.replaceAll(" ", "") +
             "_Presupuesto.pdf"
         );*/
      }
    },

    async _generarPresupuestoIngles() {
      if (this.modelReserva.id != null) {
        var docDefinition = await this.reportePresupuestoIngles([
          this.modelReserva,
          this.presupuestoImagen1,
          this.presupuestoImagen2,
          this.presupuestoImagen3,
          this.presupuestoImagen4,
          this.presupuestoImagen5,
          this.presupuestoImagen6,
          this.presupuestoImagen7,
          this.presupuestoImagen8,
          this.presupuestoImagen12,
          this.presupuestoImagen13,
          this.presupuestoImagen14,
          this.tarifaSEUR,
          this.tarifaKm,
          this.importe_s,
          this.importe_m,
          this.importe_l,
          this.importe_xl,
          this.importe_ms,
          this.importe_mm,
          this.importe_ml,
          this.tarifaMenosDe7,
          this.tarifaMasDe7,
          this.imprimirSoloPaginaPrincipal,
        ]);

        this.dialogCamposPresupuesto = false;

        pdfMake
          .createPdf(docDefinition)
          .download(
            this.modelReserva.cod_presupuesto +
            "_" +
            this.modelReserva.cliente.nombre.replaceAll(" ", "") +
            "_Presupuesto.pdf"
          );

        /* require("electron").shell.showItemInFolder(
           this.rutaDocumentosPresupuestos +
             this.modelReserva.created_at.substring(0, 10).replaceAll("-", "") +
             "_" +
             this.modelReserva.id.toString() +
             "_" +
             this.modelReserva.cliente.nombre.replaceAll(" ", "") +
             "_Presupuesto.pdf"
         );*/
      }
    },

    async _generarPresupuestoPortugues() {
      if (this.modelReserva.id != null) {
        var docDefinition = await this.reportePresupuestoPortugues([
          this.modelReserva,
          this.presupuestoImagen1,
          this.presupuestoImagen2,
          this.presupuestoImagen3,
          this.presupuestoImagen4,
          this.presupuestoImagen5,
          this.presupuestoImagen6,
          this.presupuestoImagen7,
          this.presupuestoImagen8,
          this.presupuestoImagen12,
          this.presupuestoImagen13,
          this.presupuestoImagen14,
          this.tarifaSEUR,
          this.tarifaKm,
          this.importe_s,
          this.importe_m,
          this.importe_l,
          this.importe_xl,
          this.importe_ms,
          this.importe_mm,
          this.importe_ml,
          this.tarifaMenosDe7,
          this.tarifaMasDe7,
          this.imprimirSoloPaginaPrincipal,
        ]);

        this.dialogCamposPresupuesto = false;

        pdfMake
          .createPdf(docDefinition)
          .download(
            this.modelReserva.cod_presupuesto +
            "_" +
            this.modelReserva.cliente.nombre.replaceAll(" ", "") +
            "_Presupuesto.pdf"
          );

        /* require("electron").shell.showItemInFolder(
           this.rutaDocumentosPresupuestos +
             this.modelReserva.created_at.substring(0, 10).replaceAll("-", "") +
             "_" +
             this.modelReserva.id.toString() +
             "_" +
             this.modelReserva.cliente.nombre.replaceAll(" ", "") +
             "_Presupuesto.pdf"
         );*/
      }
    },

    _mostrarDialogPresupuesto() {
      this.imprimirSoloPaginaPrincipal = !!this.modelReserva.descuento_agencia;
      this.dialogCamposPresupuesto = true;
    },

    _mostrarDialogConfirmacion() {
      this.campoConfirmacionFecha = this.modelReserva.created_at.substr(0, 10);
      this.campoConfirmacionObservaciones = this.modelReserva.observaciones;
      this.dialogCamposConfirmacion = true;
    },

    _mostrarDialogConfirmacionAgencia() {
      this.campoConfirmacionFechaAgencia = this.modelReserva.created_at.substr(0, 10);
      this.campoConfirmacionObservacionesAgencia = this.modelReserva.observaciones;
      this.campoConfirmacionAgenciaClienteNombre = "";
      this.campoConfirmacionAgenciaClienteDNI = "";
      this.campoConfirmacionAgenciaClienteDomicilio = "";
      this.campoConfirmacionAgenciaClienteTelefono = "";
      this.campoConfirmacionAgenciaClienteEmail = "";
      this.dialogCamposConfirmacionAgencia = true;
    },

    _mostrarDialogObtenerUrlPago() {
      console.log('modelReserva:', this.modelReserva);
      this.campoObtenerUrlPagoImporte = this.modelReserva.importe;
      this.campoObtenerUrlPagoCodigo = this.modelReserva.cod_presupuesto.substring(2) + "_";
      this.dialogCamposObtenerUrlPago = true;
    },

    async _generarConfirmacion(con_condiciones) {
      if (this.modelReserva.id != null) {
        var complementos_importe = this.validarCampoNumero(this.modelReserva.pedales_automaticos_importe) +
          this.validarCampoNumero(this.modelReserva.seguro_importe) +
          this.validarCampoNumero(this.modelReserva.bolsa_delantera_importe) +
          this.validarCampoNumero(this.modelReserva.soporte_movil_importe) +
          this.validarCampoNumero(this.modelReserva.credencial_importe);


        var docDefinition = await this.reporteConfirmacion([
          con_condiciones,
          this.modelReserva,
          this.presupuestoImagen7,
          this.imagenFirma,
          this.importe_s,
          this.importe_m,
          this.importe_l,
          this.importe_xl,
          this.importe_ms,
          this.importe_mm,
          this.importe_ml,
          this.campoConfirmacionFecha,
          this.campoConfirmacionObservaciones,
          complementos_importe
        ]);

        this.dialogCamposConfirmacion = false;

        pdfMake
          .createPdf(docDefinition)
          .download(
            this.modelReserva.cod_presupuesto +
            "_" +
            this.modelReserva.cliente.nombre.replaceAll(" ", "") +
            "_Confirmacion.pdf"
          );

        /* require("electron").shell.showItemInFolder(
           this.rutaDocumentosConfirmaciones +
             this.modelReserva.created_at.substring(0, 10).replaceAll("-", "") +
             "_" +
             this.modelReserva.id.toString() +
             "_" +
             this.modelReserva.cliente.nombre.replaceAll(" ", "") +
             "_Confirmacion.pdf"
         );*/
      }
    },

    async _generarConfirmacionAgencia(con_condiciones) {
      if (this.modelReserva.id != null) {
        var complementos_importe = this.validarCampoNumero(this.modelReserva.pedales_automaticos_importe) +
          this.validarCampoNumero(this.modelReserva.seguro_importe) +
          this.validarCampoNumero(this.modelReserva.bolsa_delantera_importe) +
          this.validarCampoNumero(this.modelReserva.soporte_movil_importe) +
          this.validarCampoNumero(this.modelReserva.credencial_importe);

        var docDefinition = await this.reporteConfirmacionAgencia([
          con_condiciones,
          this.modelReserva,
          this.presupuestoImagen7,
          this.imagenFirma,
          this.importe_s,
          this.importe_m,
          this.importe_l,
          this.importe_xl,
          this.importe_ms,
          this.importe_mm,
          this.importe_ml,
          this.campoConfirmacionFechaAgencia,
          this.campoConfirmacionObservacionesAgencia,
          this.campoConfirmacionAgenciaClienteNombre,
          this.campoConfirmacionAgenciaClienteDNI,
          this.campoConfirmacionAgenciaClienteDomicilio,
          this.campoConfirmacionAgenciaClienteTelefono,
          this.campoConfirmacionAgenciaClienteEmail,
          complementos_importe
        ]);

        this.dialogCamposConfirmacionAgencia = false;

        pdfMake
          .createPdf(docDefinition)
          .download(
            this.modelReserva.cod_presupuesto +
            "_" +
            this.modelReserva.cliente.nombre.replaceAll(" ", "") +
            "_Confirmacion.pdf"
          );

      }
    },

    async _generarConfirmacionIngles(con_condiciones) {
      if (this.modelReserva.id != null) {
        var complementos_importe = this.validarCampoNumero(this.modelReserva.pedales_automaticos_importe) +
          this.validarCampoNumero(this.modelReserva.seguro_importe) +
          this.validarCampoNumero(this.modelReserva.bolsa_delantera_importe) +
          this.validarCampoNumero(this.modelReserva.soporte_movil_importe) +
          this.validarCampoNumero(this.modelReserva.credencial_importe);

        var docDefinition = await this.reporteConfirmacionIngles([
          con_condiciones,
          this.modelReserva,
          this.presupuestoImagen7,
          this.imagenFirma,
          this.importe_s,
          this.importe_m,
          this.importe_l,
          this.importe_xl,
          this.importe_ms,
          this.importe_mm,
          this.importe_ml,
          this.campoConfirmacionFecha,
          this.campoConfirmacionObservaciones,
          complementos_importe
        ]);

        this.dialogCamposConfirmacion = false;

        pdfMake
          .createPdf(docDefinition)
          .download(
            this.modelReserva.cod_presupuesto +
            "_" +
            this.modelReserva.cliente.nombre.replaceAll(" ", "") +
            "_Confirmacion.pdf"
          );

        /* require("electron").shell.showItemInFolder(
           this.rutaDocumentosConfirmaciones +
             this.modelReserva.created_at.substring(0, 10).replaceAll("-", "") +
             "_" +
             this.modelReserva.id.toString() +
             "_" +
             this.modelReserva.cliente.nombre.replaceAll(" ", "") +
             "_Confirmacion.pdf"
         );*/
      }
    },

    async _generarConfirmacionPortugues(con_condiciones) {
      if (this.modelReserva.id != null) {
        var complementos_importe = this.validarCampoNumero(this.modelReserva.pedales_automaticos_importe) +
          this.validarCampoNumero(this.modelReserva.seguro_importe) +
          this.validarCampoNumero(this.modelReserva.bolsa_delantera_importe) +
          this.validarCampoNumero(this.modelReserva.soporte_movil_importe) +
          this.validarCampoNumero(this.modelReserva.credencial_importe);

        var docDefinition = await this.reporteConfirmacionPortugues([
          con_condiciones,
          this.modelReserva,
          this.presupuestoImagen7,
          this.imagenFirma,
          this.importe_s,
          this.importe_m,
          this.importe_l,
          this.importe_xl,
          this.importe_ms,
          this.importe_mm,
          this.importe_ml,
          this.campoConfirmacionFecha,
          this.campoConfirmacionObservaciones,
          complementos_importe
        ]);

        this.dialogCamposConfirmacion = false;

        pdfMake
          .createPdf(docDefinition)
          .download(
            this.modelReserva.cod_presupuesto +
            "_" +
            this.modelReserva.cliente.nombre.replaceAll(" ", "") +
            "_Confirmacion.pdf"
          );

        /* require("electron").shell.showItemInFolder(
           this.rutaDocumentosConfirmaciones +
             this.modelReserva.created_at.substring(0, 10).replaceAll("-", "") +
             "_" +
             this.modelReserva.id.toString() +
             "_" +
             this.modelReserva.cliente.nombre.replaceAll(" ", "") +
             "_Confirmacion.pdf"
         );*/
      }
    },

    _mostrarDialogContrato() {
      this.campoContratoHoraInicio = "09:00";
      this.campoContratoHoraFin = "21:00";
      this.campoContratoCasco = "";
      this.campoContratoCandado = "";
      this.campoContratoCargador = "";
      this.campoContratoKitPinchazos = "";
      this.campoContratoAlforjas = "";
      this.campoContratoBateriaExtra = "";
      this.campoContratoObservaciones = "";


      this.dialogCamposContrato = true;
    },

    async _generarContrato() {
      if (this.modelReserva.id != null) {
        var docDefinition = await this.reporteContrato([
          this.modelReserva,
          this.presupuestoImagen7,
          this.imagenFirma,
          this.campoContratoHoraInicio,
          this.campoContratoHoraFin,
          this.campoContratoCasco,
          this.campoContratoCandado,
          this.campoContratoCargador,
          this.campoContratoKitPinchazos,
          this.campoContratoAlforjas,
          this.campoContratoBateriaExtra,
          this.campoContratoObservaciones,
        ]);

        this.dialogCamposContrato = false;

        pdfMake
          .createPdf(docDefinition)
          .download(
            this.modelReserva.cod_presupuesto +
            "_" +
            this.modelReserva.cliente.nombre.replaceAll(" ", "") +
            "_Contrato.pdf"
          );

        /* require("electron").shell.showItemInFolder(
           this.rutaDocumentosContratos +
             this.modelReserva.created_at.substring(0, 10).replaceAll("-", "") +
             "_" +
             this.modelReserva.id.toString() +
             "_" +
             this.modelReserva.cliente.nombre.replaceAll(" ", "") +
             "_Contrato.pdf"
         );*/
      }
    },


    async _generarContratoPortuges() {
      if (this.modelReserva.id != null) {
        var docDefinition = await this.reporteContratoPortuges([
          this.modelReserva,
          this.presupuestoImagen7,
          this.imagenFirma,
          this.campoContratoHoraInicio,
          this.campoContratoHoraFin,
          this.campoContratoCasco,
          this.campoContratoCandado,
          this.campoContratoCargador,
          this.campoContratoKitPinchazos,
          this.campoContratoAlforjas,
          this.campoContratoBateriaExtra,
          this.campoContratoObservaciones,
        ]);

        this.dialogCamposContrato = false;

        pdfMake
          .createPdf(docDefinition)
          .download(
            this.modelReserva.cod_presupuesto +
            "_" +
            this.modelReserva.cliente.nombre.replaceAll(" ", "") +
            "_Contrato.pdf"
          );

        /* require("electron").shell.showItemInFolder(
           this.rutaDocumentosContratos +
             this.modelReserva.created_at.substring(0, 10).replaceAll("-", "") +
             "_" +
             this.modelReserva.id.toString() +
             "_" +
             this.modelReserva.cliente.nombre.replaceAll(" ", "") +
             "_Contrato.pdf"
         );*/
      }
    },

    async _generarContratoIngles() {
      if (this.modelReserva.id != null) {
        var docDefinition = await this.reporteContratoIngles([
          this.modelReserva,
          this.presupuestoImagen7,
          this.imagenFirma,
          this.campoContratoHoraInicio,
          this.campoContratoHoraFin,
          this.campoContratoCasco,
          this.campoContratoCandado,
          this.campoContratoCargador,
          this.campoContratoKitPinchazos,
          this.campoContratoAlforjas,
          this.campoContratoBateriaExtra,
          this.campoContratoObservaciones,
        ]);

        this.dialogCamposContrato = false;

        pdfMake
          .createPdf(docDefinition)
          .download(
            this.modelReserva.cod_presupuesto +
            "_" +
            this.modelReserva.cliente.nombre.replaceAll(" ", "") +
            "_Contrato.pdf"
          );

        /* require("electron").shell.showItemInFolder(
           this.rutaDocumentosContratos +
             this.modelReserva.created_at.substring(0, 10).replaceAll("-", "") +
             "_" +
             this.modelReserva.id.toString() +
             "_" +
             this.modelReserva.cliente.nombre.replaceAll(" ", "") +
             "_Contrato.pdf"
         );*/
      }
    },

    async _mostrarDialogFactura() {
      this.campoFacturaClienteNombre = this.modelReserva.cliente.nombre;
      this.campoFacturaClienteDNI = this.modelReserva.cliente.dni;
      this.campoFacturaClienteDomicilio = this.modelReserva.cliente.domicilio;
      this.campoFacturaNumeroFactura =
        this.modelReserva.factura != null ? String(this.modelReserva.factura) : "";
      this.campoFacturaNumeroFacturaOriginal = this.campoFacturaNumeroFactura.trim();
      this.campoFacturaCuentaBancaria1 = "ABANCA: ES83 2080 0306 5130 4002 5574";
      this.campoFacturaBicCuenta1 = "CAGLESMMXXX";
      this.campoFacturaCuentaBancaria2 = "CAIXABANK: ES82 2100 4775 2502 0038 4614";
      this.campoFacturaBicCuenta2 = "CAIXESBBXXX";

      // Reiniciar filas para no arrastrar datos de una factura anterior.
      this.campoFacturaFilas.forEach((fila) => {
        fila.descripcion = "";
        fila.unidades = "";
        fila.precio = "";
        fila.importe = "";
      });

      const cantBicisElectricas =
        this.modelReserva.cant_bicis_s +
        this.modelReserva.cant_bicis_m +
        this.modelReserva.cant_bicis_l +
        this.modelReserva.cant_bicis_xl;
      const cantBicisMusculares =
        this.modelReserva.cant_bicis_ms +
        this.modelReserva.cant_bicis_mm +
        this.modelReserva.cant_bicis_ml;

      this.campoFacturaFilas[0].descripcion =
        "Alquiler " +
        cantBicisElectricas +
        " ebikes\n" +
        this.modelReserva.cant_dias +
        " días de " +
        this._captionFecha(this.modelReserva.fecha_inicial) +
        " hasta " +
        this._captionFecha(this.modelReserva.fecha_final);

      this.campoFacturaFecha = this.modelReserva.fecha_inicial;

      this.campoFacturaFilas[0].unidades =
        cantBicisElectricas +
        " (" +
        this.modelReserva.cant_dias +
        " días)";

      if (this.modelReserva.cant_dias > 0 && this.modelReserva.cant_dias <= 7) {
        if (this.modelReserva.descuento_agencia) {
          this.campoFacturaFilas[0].precio = this._formatImporteFactura(parseFloat(
            parseFloat(this.tarifaMenosDe7Agencia) / 1.21
          ).toFixed(2));
        } else {
          this.campoFacturaFilas[0].precio = this._formatImporteFactura(this.tarifaMenosDe7SinIVA);
        }
      } else if (this.modelReserva.cant_dias > 7) {
        if (this.modelReserva.descuento_agencia) {
          this.campoFacturaFilas[0].precio = this._formatImporteFactura(parseFloat(
            parseFloat(this.tarifaMasDe7Agencia) / 1.21
          ).toFixed(2));
        } else {
          this.campoFacturaFilas[0].precio = this._formatImporteFactura(this.tarifaMasDe7SinIVA);
        }
      }

      this.campoFacturaFilas[0].importe = this._formatImporteFactura(parseFloat(
        parseFloat(cantBicisElectricas) *
        parseFloat(this.modelReserva.cant_dias) *
        this._parseImporteFactura(this.campoFacturaFilas[0].precio)
      ).toFixed(2));


      if (this.modelReserva.cant_dias > 0 && this.modelReserva.cant_dias <= 7) {
        if (this.modelReserva.descuento_agencia) {
          this.campoFacturaPrecioAlquilerMuscular = parseFloat(
            parseFloat(this.muscularMenosDe7Agencia) / 1.21
          ).toFixed(2);
        } else {
          this.campoFacturaPrecioAlquilerMuscular = this.muscularMenosDe7SinIVA;
        }
      } else if (this.modelReserva.cant_dias > 7) {
        if (this.modelReserva.descuento_agencia) {
          this.campoFacturaPrecioAlquilerMuscular = parseFloat(
            parseFloat(this.muscularMasDe7Agencia) / 1.21
          ).toFixed(2);
        } else {
          this.campoFacturaPrecioAlquilerMuscular = this.muscularMasDe7SinIVA;
        }
      }

      let indiceFila = 1;

      if (cantBicisMusculares > 0) {
        const importeAlquilerMuscular = parseFloat(
          parseFloat(cantBicisMusculares) *
          parseFloat(this.modelReserva.cant_dias) *
          this._parseImporteFactura(this.campoFacturaPrecioAlquilerMuscular)
        ).toFixed(2);

        this.campoFacturaFilas[indiceFila].descripcion =
          "Alquiler " +
          cantBicisMusculares +
          " bicicletas musculares\n" +
          this.modelReserva.cant_dias +
          " días de " +
          this._captionFecha(this.modelReserva.fecha_inicial) +
          " hasta " +
          this._captionFecha(this.modelReserva.fecha_final);
        this.campoFacturaFilas[indiceFila].unidades =
          cantBicisMusculares + " (" + this.modelReserva.cant_dias + " días)";
        this.campoFacturaFilas[indiceFila].precio =
          this._formatImporteFactura(this.campoFacturaPrecioAlquilerMuscular);
        this.campoFacturaFilas[indiceFila].importe =
          this._formatImporteFactura(importeAlquilerMuscular);
        indiceFila = indiceFila + 1;
      }




      if (
        this.modelReserva.transporte_importe != null &&
        this.modelReserva.transporte_importe > 0
      ) {
        if (!this.modelReserva.sin_iva) {
          this.campoFacturaPrecioTransporte = parseFloat(
            parseFloat(this.modelReserva.transporte_importe) / 1.21
          ).toFixed(2);
        } else {
          this.campoFacturaPrecioTransporte = parseFloat(
            this.modelReserva.transporte_importe
          ).toFixed(2);
        }
      } else {
        this.campoFacturaPrecioTransporte = "";
      }

      if (this.campoFacturaPrecioTransporte != "" && parseFloat(this.campoFacturaPrecioTransporte) > 0) {
        this.campoFacturaFilas[indiceFila].descripcion =
          "Transporte " +
          (this.modelReserva.ubicacion_inicial != null
            ? this.modelReserva.ubicacion_inicial
            : "") +
          " - " +
          (this.modelReserva.ubicacion_final != null
            ? this.modelReserva.ubicacion_final
            : "");
        this.campoFacturaFilas[indiceFila].unidades = "1";
        this.campoFacturaFilas[indiceFila].precio =
          this._formatImporteFactura(this.campoFacturaPrecioTransporte);
        this.campoFacturaFilas[indiceFila].importe =
          this._formatImporteFactura(this.campoFacturaPrecioTransporte);
      }

      if (this.modelReserva.id != null && this.campoFacturaNumeroFacturaOriginal == "") {
        const facturaGenerada = await this.asignarNumeroFactura([
          this.access_token,
          this.modelReserva.id,
        ]);
        if (facturaGenerada != null && String(facturaGenerada).trim() !== "") {
          this.modelReserva.factura = facturaGenerada;
          this.campoFacturaNumeroFactura = String(facturaGenerada);
          this.campoFacturaNumeroFacturaOriginal = String(facturaGenerada).trim();
        }
      }

      this._recalcularTotalesFactura();
      this.dialogCamposFactura = true;
    },

    async _generarFactura() {
    //  alert('Está en desarrollo. Pronto estará operativa.');
      if (this.modelReserva.id != null) {
        const facturaActual = this.campoFacturaNumeroFactura != null
          ? String(this.campoFacturaNumeroFactura).trim()
          : "";
        const facturaOriginal = this.campoFacturaNumeroFacturaOriginal != null
          ? String(this.campoFacturaNumeroFacturaOriginal).trim()
          : "";
        const facturaEditada = facturaActual !== facturaOriginal;

        if (facturaEditada) {
          const facturaParaEndpoint = facturaActual !== "" ? facturaActual : undefined;
          var res = await this.asignarNumeroFactura([
            this.access_token,
            this.modelReserva.id,
            facturaParaEndpoint,
          ]);

          if (res != null && String(res).trim() !== "") {
            this.modelReserva.factura = res;
            this.campoFacturaNumeroFactura = String(res);
            this.campoFacturaNumeroFacturaOriginal = String(res).trim();
          } else {
            this.modelReserva.factura = facturaActual;
            this.campoFacturaNumeroFacturaOriginal = facturaActual;
          }
        } else if (facturaActual !== "") {
          this.modelReserva.factura = facturaActual;
        }

        var docDefinition = await this.reporteFactura([
          this.modelReserva,
          this.presupuestoImagen7,
          this.imagenFirma,
          this.importe_s,
          this.importe_m,
          this.importe_l,
          this.importe_xl,
          this.campoFacturaFilas,
          this.campoFacturaClienteNombre,
          this.campoFacturaClienteDNI,
          this.campoFacturaClienteDomicilio,
          this.campoFacturaDescripcionAlquiler,
          this.campoFacturaDescripcionTransporte,
          this.campoFacturaPrecioAlquiler,
          this.campoFacturaPrecioTransporte,
          this.campoFacturaFecha,
          this.campoFacturaPrecioAlquilerMuscular,
          this.campoFacturaNumeroFactura,
          this.campoFacturaBaseImponible,
          this.campoFacturaIVA,
          this.campoFacturaTotal,
          this.campoFacturaCuentaBancaria1,
          this.campoFacturaBicCuenta1,
          this.campoFacturaCuentaBancaria2,
          this.campoFacturaBicCuenta2
        ]);

        this.dialogCamposFactura = false;

         var res = await pdfMake
           .createPdf(docDefinition)
           .download(
             this.campoFacturaFecha.substring(0, 10).replaceAll("-", "") +
               "_" +
               this.modelReserva.id.toString() +
               "_" +
               this.modelReserva.cliente.nombre.replaceAll(" ", "") +
               "_Factura.pdf"
           ); 

        /* require("electron").shell.showItemInFolder(
           this.rutaDocumentosFacturas +
             this.modelReserva.created_at.substring(0, 10).replaceAll("-", "") +
             "_" +
             this.modelReserva.id.toString() +
             "_" +
             this.modelReserva.cliente.nombre.replaceAll(" ", "") +
             "_Factura.pdf"
         );*/
      }
    },

    async _obtenerUrlPago() {

      
      var res = await this.obtenerUrlPago([this.access_token, this.modelReserva.id, this.campoObtenerUrlPagoCodigo, this.campoObtenerUrlPagoImporte]);
      console.log('res:', res);
      if (res && res.payment_url) {
        let buff = Buffer.from(res.payment_url, 'base64');
        let text = buff.toString('ascii');
        let decodedData = JSON.parse(text);
        let campo = decodedData.Ds_UrlPago2Fases;
        console.log('urlpago:', campo);
        if (campo.startsWith('https')) {
           this.modelReserva.url_pago = campo;
           var res = await this.updateUrlPago([this.access_token, this.modelReserva.id, campo]);
           console.log('res:', res);
           this.dialogCamposObtenerUrlPago = false;
        }
      }
    },

    async _obtenerUrlPagoCeca() {

      var res = await this.obtenerUrlPagoCeca([this.access_token, this.modelReserva.id, this.campoObtenerUrlPagoCodigo, this.campoObtenerUrlPagoImporte]);
      console.log('res:', res);
      if (res && res.payment_url) {
        let buff = Buffer.from(res.payment_url, 'base64');
        let text = buff.toString('ascii');
        let decodedData = JSON.parse(text);
        let campo = decodedData.Ds_UrlPago2Fases;
        console.log('urlpago:', campo);
        if (campo.startsWith('https')) {
           this.modelReserva.url_pago = campo;
           var res = await this.updateUrlPago([this.access_token, this.modelReserva.id, campo]);
           console.log('res:', res);
           this.dialogCamposObtenerUrlPago = false;
        }
      }
    }

  },
};
</script>

<style scoped>
:deep(.my-custom-dialog) {
  align-self: flex-start;
}

.text-field-reducido {
  width: 100px;
  /* Cambia 200px al ancho deseado */
}
</style>
